/* ============ DATA ============ */
/* Sourced from the "Main content (JS app)" section's theme-editor
   settings/blocks (see sections/main-custom.liquid), with the original
   content preserved as a fallback so nothing changes until a merchant
   edits it in Shopify admin. */
const CONTENT = (window.THEME_CONTENT) || {};
const PRODUCTS = CONTENT.products || [];
const REVIEWS = CONTENT.reviews || [];
const PFAQ = (CONTENT.faqs || []).slice(0,4);
const PFAQ_EXTRA = CONTENT.faqs || [];
const CATS = (function(){
  const seen = [];
  PRODUCTS.forEach(p=>{ if (p.cat && !seen.includes(p.cat)) seen.push(p.cat); });
  return seen;
})();
const ARWORDS=["Allah","Bismillah","Ar-Rahman","Nur","Sabr","Salaam","Rahmah","Iman","Karim","Hubb","Shukr","Barakah"];
const STYLES=["e","g","c","b","d"];

/* ============ STATE ============ */
let CART=[],
    shopFilter="All",
    shopSort="featured",
    shopSearch="",
    shopShown=8,
    shopPriceMax=999999;
let WISHLIST = JSON.parse(localStorage.getItem('al_wl') || '[]');
let RECENT   = JSON.parse(localStorage.getItem('al_rv') || '[]');
let COMPARE  = [];
let _pdpImages = [];

/* ── Quiz state ─────────────────────────────────────────────── */
let _quizAnswers = [];
let _quizQ = 0;

/* ============ HELPERS ============ */
function money(n){ return (THEME.currencyPrefix||'SAR') + ' ' + n; }
function artTile(p,cls=""){
  if (p.image) {
    return `<div class="art photo ${cls}">
      <img class="art-img" src="${p.image}" alt="${p.name||''}" loading="lazy" decoding="async">
      <span class="frame"></span>
    </div>`;
  }
  return `<div class="art ${p.style} ${cls}">
    <span class="cal ar" lang="ar" aria-label="${p.ar}">${p.ar}</span><span class="frame"></span>
  </div>`;
}
/* Product-card media: default photo, crossfades to image2 (then
   image3) on hover. No scale/zoom/blur — opacity-only swap between
   stacked, identically-sized layers, so there is no layout shift.
   Falls back to a single static image (or the letter tile) when a
   product doesn't have extra photos — nothing animates in that case. */
function cardMedia(p,cls=""){
  if (!p.image) return artTile(p,cls);
  // Use images[] array if present; limit card swap to first 2 only (main + hover)
  const allImgs = p.images && p.images.length ? p.images : [p.image, p.image2, p.image3].filter(Boolean);
  const imgs = allImgs.slice(0,2);
  if (imgs.length < 2) {
    return `<div class="art photo ${cls}">
      <img class="art-img" src="${p.image}" alt="${p.name||''}" loading="lazy" decoding="async">
      <span class="frame"></span>
    </div>`;
  }
  const layers = imgs.map((src,i)=>
    `<img class="art-img${i===0?' cimg-active':''}" src="${src}" alt="${p.name||''} — view ${i+1}" loading="lazy" decoding="async">`
  ).join('');
  return `<div class="art photo card-swap ${cls}">
    ${layers}
    <span class="frame"></span>
  </div>`;
}
/* Starts the hover sequence: image2 immediately (crossfades over
   .25s via CSS), then image3 after a short delay if present and the
   cursor is still on the card. Timers live on the element itself. */
function cardSwapStart(wrap){
  const stack = wrap.querySelector('.card-swap');
  if (!stack) return;
  cardSwapClear(stack);
  const imgs = stack.querySelectorAll('.art-img');
  if (imgs.length < 2) return;
  imgs.forEach((im,i)=>im.classList.toggle('cimg-active', i===1));
  if (imgs.length > 2) {
    stack._swapTimer = setTimeout(()=>{
      imgs.forEach((im,i)=>im.classList.toggle('cimg-active', i===2));
    }, 1000);
  }
}
/* Cursor leaves: cancel any pending step and fade straight back to
   the first photo (same smooth opacity transition, just reversed). */
function cardSwapStop(wrap){
  const stack = wrap.querySelector('.card-swap');
  if (!stack) return;
  cardSwapClear(stack);
  stack.querySelectorAll('.art-img').forEach((im,i)=>im.classList.toggle('cimg-active', i===0));
}
function cardSwapClear(stack){
  if (stack._swapTimer) { clearTimeout(stack._swapTimer); stack._swapTimer = null; }
}
function card(p){
  const wlOn = WISHLIST.includes(String(p.id)) ? 'wl-on' : '';
  const inCmp = COMPARE.some(x=>String(x.id)===String(p.id));
  const qvBtnLabel = (THEME.features && THEME.features.enableQuickView !== false) ? 'Quick View' : 'View';
  const qvBtnAction = (THEME.features && THEME.features.enableQuickView !== false) ? `quickView('${p.id}')` : `go('product-${p.id}')`;
  const showWl = !(THEME.features && THEME.features.enableWishlist === false);
  const showCmp = !(THEME.features && THEME.features.enableCompare === false);
  return `<div class="card lux-card" onclick="go('product-${p.id}',event)" onmouseenter="cardSwapStart(this)" onmouseleave="cardSwapStop(this)">
    ${p.badge?`<span class="badge">${p.badge}</span>`:''}
    ${showWl ? `<button class="wl-btn ${wlOn}" onclick="event.stopPropagation();toggleWishlist(${p.id},this)" aria-label="Wishlist">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="18" height="18">
        <path d="M12 21C12 21 3 14.5 3 8.5C3 6 5 4 7.5 4C9 4 10.5 4.8 12 6.5C13.5 4.8 15 4 16.5 4C19 4 21 6 21 8.5C21 14.5 12 21 12 21Z"
          stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" class="wl-path"/>
      </svg>
    </button>` : ''}
    <div class="card-art-wrap">${cardMedia(p)}
      <div class="quick">
        <button onclick="event.stopPropagation();cardAddToCart('${p.id}',this)">Add to Cart</button>
        <button onclick="event.stopPropagation();${qvBtnAction}">${qvBtnLabel}</button>
      </div>
    </div>
    <div class="cap">
      <div class="name">${p.name}</div>
      <div class="meta">
        <span class="stars">${'★'.repeat(p.rating)}${'☆'.repeat(5-p.rating)}</span>
        <span class="price">${money(p.price)}</span>
      </div>
      ${showCmp ? `<div class="cmp-btn ${inCmp?'in-compare':''}" onclick="event.stopPropagation();addToCompare(${p.id})">
        ${inCmp?'✓ Comparing':'⊕ Compare'}
      </div>` : ''}
    </div>
  </div>`;
}

function cardAddToCart(id,btn){
  addToCart(id);
  btn.textContent='✓ Added';
  btn.style.background='var(--emerald)';
  btn.style.color='#fff';
  setTimeout(()=>{btn.textContent='Add to Cart';btn.style.background='';btn.style.color='';},1800);
}
function stars(n){ return '★'.repeat(n)+'☆'.repeat(5-n); }

/* ============ QUICK VIEW ============ */
function quickView(id) {
  const p = PRODUCTS.find(x => String(x.id) === String(id));
  if (!p) return;
  const galleryImages = (p.images && p.images.length) ? p.images : [p.image, p.image2, p.image3].filter(Boolean);
  const sizesArr = p.sizes ? p.sizes.split(',').map(function(s){return s.trim();}) : ['40×40cm','60×60cm','80×80cm'];
  const t = (THEME.trust || {});

  const modal = document.getElementById('qvModal');
  const innerEl = document.getElementById('qvInner');
  if (!modal || !innerEl) return;

  const mainImgHTML = galleryImages.length
    ? '<div class="art photo qv-main-art" id="qvMainArt" style="cursor:zoom-in" onclick="openPhotoLB(' + JSON.stringify(galleryImages) + ',0)">'
      + '<img class="art-img" src="' + galleryImages[0] + '" alt="' + (p.name||'') + '" loading="eager" decoding="async" fetchpriority="high">'
      + '<span class="frame"></span></div>'
    : '<div class="art ' + p.style + ' qv-main-art" id="qvMainArt">'
      + '<span class="cal ar" lang="ar" aria-label="' + (p.ar||'') + '">' + (p.ar||'') + '</span><span class="frame"></span></div>';

  const thumbsHTML = galleryImages.length > 1
    ? '<div class="qv-thumbs">'
      + galleryImages.map(function(img,i){
          return '<div class="art photo ' + (i===0?'active':'') + '" onclick="qvSwapPhoto(\'' + img + '\',this)">'
            + '<img class="art-img" src="' + img + '" alt="' + (p.name||'') + ' view ' + (i+1) + '" loading="lazy" decoding="async"></div>';
        }).join('')
      + '</div>'
    : '';

  innerEl.innerHTML = '<div class="qv-gallery">' + mainImgHTML + thumbsHTML + '</div>'
    + '<div class="qv-info">'
    + '<p class="eyebrow">' + (p.cat||'') + '</p>'
    + '<h2 class="qv-name">' + (p.name||'') + '</h2>'
    + '<div class="stars" style="font-size:14px;margin:10px 0">' + '★'.repeat(p.rating) + '☆'.repeat(5-p.rating) + '</div>'
    + '<div class="qv-price">' + money(p.price) + (p.was ? '<span class="was" style="color:#999;text-decoration:line-through;font-size:16px;margin-left:10px">' + money(p.was) + '</span>' : '') + '</div>'
    + '<div class="variant-group" style="margin:18px 0"><div class="vlabel">Size</div>'
    + '<div class="vopts">' + sizesArr.map(function(s,i){return '<button class="vopt ' + (i===0?'active':'') + '" onclick="pick(this)">' + s + '</button>';}).join('') + '</div></div>'
    + '<div class="variant-group" style="margin:18px 0"><div class="vlabel">Quantity</div>'
    + '<div class="qty"><button onclick="qtyChg(-1,\'qvQty\')">−</button><span id="qvQty">1</span><button onclick="qtyChg(1,\'qvQty\')">+</button></div></div>'
    + '<div style="display:flex;gap:10px;margin-top:20px;flex-wrap:wrap">'
    + '<button class="btn emerald" style="flex:1;justify-content:center;min-width:140px" onclick="addToCart(\'' + p.id + '\',+document.getElementById(\'qvQty\').textContent);closeQuickView()">Add to Cart — ' + money(p.price) + '</button>'
    + '<button class="btn ghost" style="padding:16px 22px" onclick="closeQuickView();go(\'product-' + p.id + '\')">Full Details →</button>'
    + '</div>'
    + '<div class="qv-trust">'
    + '<span>✓ ' + (t.badge1||'Premium Acrylic') + '</span>'
    + '<span>✓ ' + (t.badge3||'Secure Payment') + '</span>'
    + '<span>✓ ' + (t.badge4||'Fast Delivery Across Saudi Arabia') + '</span>'
    + '<span>✓ ' + (t.badge5||'Easy Installation') + '</span>'
    + '</div></div>';

  modal.setAttribute('aria-hidden','false');
  document.getElementById('qvOverlay').classList.add('on');
  modal.classList.add('on');
  document.body.classList.add('qv-open');
}

function qvSwapPhoto(img, thumb) {
  var main = document.getElementById('qvMainArt');
  if (!main) return;
  var existImg = main.querySelector('.art-img');
  if (existImg) existImg.src = img;
  if (thumb) {
    Array.from(thumb.parentElement.children).forEach(function(t){ t.classList.remove('active'); });
    thumb.classList.add('active');
  }
}

function closeQuickView() {
  var modal = document.getElementById('qvModal');
  var overlay = document.getElementById('qvOverlay');
  if (modal) { modal.classList.remove('on'); modal.setAttribute('aria-hidden','true'); }
  if (overlay) overlay.classList.remove('on');
  document.body.classList.remove('qv-open');
}

/* ── Memoji-style animated SVG avatars ─────────────────────── */
/* 6 Apple Memoji-inspired characters: large eyes, 3D face shading,
   accessories (hijab, cap, curls, keffiyeh, long hair, natural hair).
   SMIL blink animation built in.                                      */
function buildAvatar(idx){
  const chars=[
    // 0 – woman with teal hijab, warm olive skin
    { bg:'#0B6B50', skin:'#C8885A', skinS:'#A06840', iris:'#2C1204', brow:'#2C1204',
      lip:'#C05040', cloth:'#087363',
      acc:'<ellipse cx="40" cy="20" rx="25" ry="22" fill="#0D3D2C"/>'
         +'<ellipse cx="40" cy="55" rx="34" ry="14" fill="#0D3D2C"/>'
         +'<ellipse cx="14" cy="46" rx="9" ry="16" fill="#0D3D2C"/>'
         +'<ellipse cx="66" cy="46" rx="9" ry="16" fill="#0D3D2C"/>'
    },
    // 1 – man with white cap, fair skin (Memoji-style like reference image)
    { bg:'#1A2E6E', skin:'#F0C8A0', skinS:'#D4A070', iris:'#2C1A0C', brow:'#2C1A0C',
      lip:'#C06050', cloth:'#1A2E6E',
      acc:'<ellipse cx="40" cy="18" rx="24" ry="15" fill="#EFEFEF"/>'
         +'<ellipse cx="40" cy="12" rx="18" ry="10" fill="#E8E8E8"/>'
         +'<rect x="16" y="18" width="48" height="7" rx="3.5" fill="#E0E0E0"/>'
         +'<ellipse cx="54" cy="22" rx="14" ry="5" fill="#D4D4D4"/>'
         +'<rect x="35" y="8" width="10" height="4" rx="2" fill="#C8C8C8"/>'
    },
    // 2 – woman with curly natural hair, deep brown skin
    { bg:'#4A1A60', skin:'#7A3A18', skinS:'#5A2810', iris:'#160600', brow:'#160600',
      lip:'#8A2820', cloth:'#E05040',
      acc:'<ellipse cx="40" cy="14" rx="20" ry="14" fill="#180804"/>'
         +'<ellipse cx="21" cy="25" rx="11" ry="17" fill="#180804"/>'
         +'<ellipse cx="59" cy="25" rx="11" ry="17" fill="#180804"/>'
         +'<ellipse cx="19" cy="38" rx="9" ry="11" fill="#180804"/>'
         +'<ellipse cx="61" cy="38" rx="9" ry="11" fill="#180804"/>'
    },
    // 3 – man with white keffiyeh, warm dark skin
    { bg:'#5A3010', skin:'#6A3010', skinS:'#4A2008', iris:'#160400', brow:'#1E0800',
      lip:'#7A2818', cloth:'#F0EBE0',
      acc:'<ellipse cx="40" cy="16" rx="25" ry="17" fill="#F5F2EA"/>'
         +'<rect x="15" y="14" width="50" height="7" rx="3" fill="#E0DDD5"/>'
         +'<path d="M15,21 Q11,42 14,58" stroke="#F5F2EA" stroke-width="13" fill="none" stroke-linecap="round"/>'
         +'<path d="M65,21 Q69,42 66,58" stroke="#F5F2EA" stroke-width="9" fill="none" stroke-linecap="round" opacity=".85"/>'
         +'<rect x="22" y="14" width="36" height="3" fill="#CC2020" opacity=".35"/>'
         +'<rect x="22" y="19" width="36" height="2" fill="#CC2020" opacity=".25"/>'
    },
    // 4 – woman with long dark hair, light skin, gold earrings
    { bg:'#0C3056', skin:'#F4C5B0', skinS:'#D8A090', iris:'#2A1010', brow:'#2A1010',
      lip:'#D05060', cloth:'#0C3056',
      acc:'<ellipse cx="40" cy="13" rx="22" ry="14" fill="#3A1C0C"/>'
         +'<rect x="15" y="11" width="10" height="46" rx="5" fill="#3A1C0C"/>'
         +'<rect x="55" y="11" width="10" height="46" rx="5" fill="#3A1C0C"/>'
         +'<circle cx="16" cy="50" r="3.5" fill="#E0B159" opacity=".85"/>'
         +'<circle cx="64" cy="50" r="3.5" fill="#E0B159" opacity=".85"/>'
    },
    // 5 – man with natural afro hair, medium brown skin
    { bg:'#1A1A1A', skin:'#9A6040', skinS:'#7A4020', iris:'#100600', brow:'#100600',
      lip:'#A04030', cloth:'#2A2A2A',
      acc:'<ellipse cx="40" cy="13" rx="20" ry="14" fill="#0A0804"/>'
         +'<ellipse cx="22" cy="22" rx="9" ry="14" fill="#0A0804"/>'
         +'<ellipse cx="58" cy="22" rx="9" ry="14" fill="#0A0804"/>'
         +'<ellipse cx="40" cy="9" rx="14" ry="8" fill="#141008"/>'
    },
  ];
  const c=chars[idx%6];
  const uid='av'+idx;
  const bd=(3.8+idx*0.7).toFixed(1);
  const bb=(idx*0.55).toFixed(1);
  const sm=(parseFloat(bd)*2.1).toFixed(1);
  const sb=(parseFloat(bb)+parseFloat(bd)*0.6).toFixed(1);
  return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" width="68" height="68">'
  +'<defs>'
  +'<clipPath id="'+uid+'c"><circle cx="40" cy="40" r="39"/></clipPath>'
  +'<radialGradient id="'+uid+'hl" cx="38%" cy="28%" r="55%">'
  +'<stop offset="0%" stop-color="rgba(255,255,255,.32)"/>'
  +'<stop offset="100%" stop-color="rgba(255,255,255,0)"/>'
  +'</radialGradient>'
  +'<radialGradient id="'+uid+'sh" cx="50%" cy="80%" r="55%">'
  +'<stop offset="0%" stop-color="rgba(0,0,0,.22)"/>'
  +'<stop offset="100%" stop-color="rgba(0,0,0,0)"/>'
  +'</radialGradient>'
  +'</defs>'
  // background
  +'<circle cx="40" cy="40" r="40" fill="'+c.bg+'"/>'
  // clothing / body
  +'<g clip-path="url(#'+uid+'c)">'
  +'<ellipse cx="40" cy="84" rx="40" ry="26" fill="'+c.cloth+'"/>'
  // neck
  +'<rect x="35" y="60" width="10" height="16" rx="5" fill="'+c.skin+'"/>'
  +'</g>'
  // face
  +'<g clip-path="url(#'+uid+'c)">'
  // ears
  +'<ellipse cx="18" cy="44" rx="6.5" ry="7.5" fill="'+c.skin+'"/>'
  +'<ellipse cx="62" cy="44" rx="6.5" ry="7.5" fill="'+c.skin+'"/>'
  +'<ellipse cx="17" cy="44" rx="3.5" ry="4.5" fill="'+c.skinS+'" opacity=".35"/>'
  +'<ellipse cx="63" cy="44" rx="3.5" ry="4.5" fill="'+c.skinS+'" opacity=".35"/>'
  // head / face base
  +'<ellipse cx="40" cy="43" rx="23" ry="25" fill="'+c.skin+'"/>'
  // face 3D shading
  +'<ellipse cx="40" cy="34" rx="16" ry="11" fill="rgba(255,255,255,.22)"/>'
  +'<ellipse cx="40" cy="60" rx="15" ry="8" fill="'+c.skinS+'" opacity=".22"/>'
  // accessory (hair / headwear)
  +c.acc
  // eyebrows
  +'<path d="M26,36 Q31.5,33 37,35" stroke="'+c.brow+'" stroke-width="2.4" fill="none" stroke-linecap="round"/>'
  +'<path d="M43,35 Q48.5,33 54,36" stroke="'+c.brow+'" stroke-width="2.4" fill="none" stroke-linecap="round"/>'
  // eye whites
  +'<ellipse cx="31" cy="41" rx="6.5" ry="7" fill="white"/>'
  +'<ellipse cx="49" cy="41" rx="6.5" ry="7" fill="white"/>'
  // iris + blink
  +'<ellipse cx="31" cy="41" rx="4.2" ry="4.8" fill="'+c.iris+'">'
  +'<animate attributeName="ry" values="4.8;.2;4.8" dur="'+bd+'s" begin="'+bb+'s" repeatCount="indefinite"/>'
  +'</ellipse>'
  +'<ellipse cx="49" cy="41" rx="4.2" ry="4.8" fill="'+c.iris+'">'
  +'<animate attributeName="ry" values="4.8;.2;4.8" dur="'+bd+'s" begin="'+bb+'s" repeatCount="indefinite"/>'
  +'</ellipse>'
  // pupils
  +'<ellipse cx="31" cy="41" rx="2.4" ry="2.8" fill="#0A0504">'
  +'<animate attributeName="ry" values="2.8;.15;2.8" dur="'+bd+'s" begin="'+bb+'s" repeatCount="indefinite"/>'
  +'</ellipse>'
  +'<ellipse cx="49" cy="41" rx="2.4" ry="2.8" fill="#0A0504">'
  +'<animate attributeName="ry" values="2.8;.15;2.8" dur="'+bd+'s" begin="'+bb+'s" repeatCount="indefinite"/>'
  +'</ellipse>'
  // eye shine (2 per eye — Memoji look)
  +'<circle cx="32.8" cy="38.8" r="1.6" fill="rgba(255,255,255,.95)"/>'
  +'<circle cx="50.8" cy="38.8" r="1.6" fill="rgba(255,255,255,.95)"/>'
  +'<circle cx="34.5" cy="41.6" r="0.8" fill="rgba(255,255,255,.5)"/>'
  +'<circle cx="52.5" cy="41.6" r="0.8" fill="rgba(255,255,255,.5)"/>'
  // nose
  +'<ellipse cx="36" cy="48" rx="1.6" ry="1.0" fill="'+c.skinS+'" opacity=".55"/>'
  +'<ellipse cx="44" cy="48" rx="1.6" ry="1.0" fill="'+c.skinS+'" opacity=".55"/>'
  +'<path d="M36,46 Q40,50.5 44,46" stroke="'+c.skinS+'" stroke-width="1.6" fill="none" opacity=".32"/>'
  // cheek blush
  +'<ellipse cx="23" cy="47" rx="6.5" ry="3.5" fill="'+c.lip+'" opacity=".12"/>'
  +'<ellipse cx="57" cy="47" rx="6.5" ry="3.5" fill="'+c.lip+'" opacity=".12"/>'
  // mouth / smile with morph animation
  +'<path d="M32,54 Q40,59 48,54" stroke="'+c.lip+'" stroke-width="2.6" fill="none" stroke-linecap="round">'
  +'<animate attributeName="d" values="M32,54 Q40,56 48,54;M32,54 Q40,60 48,54;M32,54 Q40,56 48,54" dur="'+sm+'s" begin="'+sb+'s" repeatCount="indefinite"/>'
  +'</path>'
  +'<path d="M33,54 Q36.5,51.5 40,52.5 Q43.5,51.5 47,54" stroke="'+c.lip+'" stroke-width="1.6" fill="none" stroke-linecap="round" opacity=".55"/>'
  // Memoji face highlight
  +'<ellipse cx="40" cy="35" rx="13" ry="9" fill="url(#'+uid+'hl)"/>'
  +'<ellipse cx="40" cy="58" rx="12" ry="7" fill="url(#'+uid+'sh)"/>'
  +'</g>'
  // outer gold ring
  +'<circle cx="40" cy="40" r="37.5" fill="none" stroke="rgba(224,177,89,.4)" stroke-width="1.5"/>'
  +'</svg>';
}

/* ── Premium review card ───────────────────────────────────── */
function reviewCard(r,i){
  const delay=(i*0.11).toFixed(2);
  const avatarHTML = r.avatar
    ? `<div class="rv-avatar rv-avatar-photo" style="animation-delay:${(i*0.38).toFixed(2)}s"><img src="${r.avatar}" alt="${r.a}" width="68" height="68" loading="lazy"></div>`
    : `<div class="rv-avatar" style="animation-delay:${(i*0.38).toFixed(2)}s">${buildAvatar(i)}</div>`;
  const productHTML = r.product ? `<div class="rv-product"><span class="rv-product-label">Purchased:</span> ${r.product}</div>` : '';
  const dateHTML = r.date ? `<span class="rv-date">${r.date}</span>` : '';
  return `<div class="rv-card rv-card-sa reveal" style="transition-delay:${delay}s">
  <div class="rv-top">
    ${avatarHTML}
    <div class="rv-meta">
      <div class="rv-name">${r.a}</div>
      <div class="rv-loc"><span class="rv-pin">📍</span> ${r.r}</div>
      <div class="rv-stars">${stars(r.s)}</div>
    </div>
    <div class="rv-badge rv-badge-gold">
      <span class="rv-badge-dot"></span>Verified Purchase
    </div>
  </div>
  ${productHTML}
  <blockquote class="rv-quote">"${r.q}"</blockquote>
  <div class="rv-foot">${dateHTML}</div>
</div>`;
}

/* ── SA customer statistics bar ───────────────────────────── */
function saStatsBarHTML(){
  return `<div class="sa-stats-bar reveal">
  <div class="sa-stat">
    <div class="sa-stat-icon">★★★★★</div>
    <div class="sa-stat-text">Average rating 4.9</div>
  </div>
  <div class="sa-stat-div" aria-hidden="true"></div>
  <div class="sa-stat">
    <div class="sa-stat-icon sa-stat-icon-sa">🇸🇦</div>
    <div class="sa-stat-text">Thousands of satisfied customers</div>
  </div>
  <div class="sa-stat-div" aria-hidden="true"></div>
  <div class="sa-stat">
    <div class="sa-stat-icon">⚡</div>
    <div class="sa-stat-text">Fast delivery across Saudi Arabia</div>
  </div>
  <div class="sa-stat-div" aria-hidden="true"></div>
  <div class="sa-stat">
    <div class="sa-stat-icon">💎</div>
    <div class="sa-stat-text">Premium acrylic quality</div>
  </div>
</div>`;
}

function statsHTML(){
  const stats = CONTENT.stats || [];
  return stats.map(s=>`
    <div class="stat">
      <div class="num" data-count="${s.count}"${s.suffix?` data-suffix="${s.suffix}"`:''}>0</div>
      <div class="lbl">${s.label}</div>
    </div>`).join('');
}

/* ============ PAGES ============ */
const PAGES={};
PAGES.home=()=>`
<section class="hero">
  <div class="hero-bg"></div>

  <!-- Calligraphy ribbon SVG (absolute, full-width background layer) -->
  <div class="ribbon-layer" id="ribbonLayer" aria-hidden="true">
    <svg class="ribbon-svg" viewBox="0 0 1440 900" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <clipPath id="ribbonClip">
          <path fill="none" stroke="#fff" stroke-width="108" stroke-linecap="butt"
            d="M -80,1058 C 62,898 214,784 442,664 C 602,590 762,518 952,429 C 1082,366 1213,294 1482,186" />
        </clipPath>
        <linearGradient id="shimGrad" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%"   stop-color="rgba(255,255,255,0)" />
          <stop offset="45%"  stop-color="rgba(255,255,255,0)" />
          <stop offset="50%"  stop-color="rgba(255,255,255,0.82)" />
          <stop offset="55%"  stop-color="rgba(255,255,255,0)" />
          <stop offset="100%" stop-color="rgba(255,255,255,0)" />
        </linearGradient>
      </defs>
      <path class="rb-body" stroke-width="88"
        d="M -80,1058 C 62,898 214,784 442,664 C 602,590 762,518 952,429 C 1082,366 1213,294 1482,186" />
      <path class="rb-thin" stroke-width="24"
        d="M 195,892 C 318,812 430,748 582,680 C 704,626 816,576 944,518 C 1054,468 1164,416 1386,336" />
      <path class="rb-edge" stroke-width="1.2"
        d="M -80,1014 C 62,854 214,740 442,620 C 602,546 762,474 952,385 C 1082,322 1213,250 1482,142" />
      <circle class="rb-dot" cx="442"  cy="664" r="7.5" />
      <circle class="rb-dot" cx="952"  cy="429" r="6"   />
      <circle class="rb-dot" cx="1213" cy="294" r="4.8" />
      <line class="rb-edge" stroke-width="1.8" x1="712"  y1="515" x2="712"  y2="470" />
      <line class="rb-edge" stroke-width="1.5" x1="1088" y1="370" x2="1088" y2="330" />
      <rect id="ribbonShimmer" class="rb-shimmer"
            x="0" y="-100" width="6000" height="1200"
            fill="url(#shimGrad)" clip-path="url(#ribbonClip)" />
    </svg>
  </div>

  <!-- Glass shapes kept off-screen for parallax JS (not visible behind panel) -->
  <div class="glass-layer" id="glassLayer" aria-hidden="true" style="display:none"></div>

  <!-- Dust particles (JS-populated) -->
  <div class="hero-dust-layer" id="heroDustLayer" aria-hidden="true"></div>

  <!-- LEFT — text content -->
  <div class="hero-head">
    <p class="eyebrow mu-eyebrow" id="muEyebrow">Hand-gilded Arabic Calligraphy</p>
    <h1 id="muH1">
      <span class="line"><span>${CONTENT.hero.headline1}</span></span>
      <span class="line"><span class="g">${CONTENT.hero.headline2}</span></span>
      <span class="line"><span>${CONTENT.hero.headline3}</span></span>
    </h1>
    <p class="hero-sub" id="muSub">${CONTENT.hero.subtext}</p>
    <div class="hero-cta" id="muCta">
      <a class="btn gold" onclick="go('shop',event)">Shop Collection</a>
    </div>
    <div class="hero-trust-line" id="muTrust">
      <span class="htl-item">🇸🇦 Trusted across Saudi Arabia</span>
      <span class="htl-sep">◆</span>
      <span class="htl-item">★ 4.9 Average Rating</span>
      <span class="htl-sep">◆</span>
      <span class="htl-item">↩ 30-Day Returns</span>
    </div>
    <div class="hero-meta" id="muMeta">
      <span>${CONTENT.heroMeta[0]}</span><span class="hdot">◆</span>
      <span>${CONTENT.heroMeta[1]}</span><span class="hdot">◆</span>
      <span>${CONTENT.heroMeta[2]}</span>
    </div>
  </div>

  <!-- RIGHT — Collections panel -->
  <div class="hero-coll-panel">
    <div class="hcoll-header">Collections</div>
    ${CATS.map(function(c){
      var count = PRODUCTS.filter(function(p){return p.cat===c;}).length;
      return '<div class="hcoll-item" onclick="shopFilter=\''+c+'\';go(\'shop\')">'
        +'<div>'
        +'<div class="hcoll-name">'+c+'</div>'
        +'<div class="hcoll-count">'+count+' piece'+(count!==1?'s':'')+'</div>'
        +'</div>'
        +'<span class="hcoll-icon">+</span>'
        +'</div>';
    }).join('')}
  </div>
</section>

<section>
  <div class="wrap">
    <div class="sec-head reveal">
      <p class="eyebrow">${CONTENT.newArrivals.eyebrow}</p>
      <div class="gold-line"></div>
      <h2>${CONTENT.newArrivals.headline}</h2>
    </div>
    <div class="grid3 stagger reveal-scale">
      ${(PRODUCTS.filter(p=>p.new).length ? PRODUCTS.filter(p=>p.new) : PRODUCTS).slice(0,6).map(card).join('')}
    </div>
    <div class="center">
      <a class="btn-link" onclick="go('shop',event)">${CONTENT.newArrivals.cta}</a>
    </div>
  </div>
</section>

<section style="background:var(--stone)">
  <div class="wrap grid2">
    <div class="reveal left">
      <p class="eyebrow">${CONTENT.story.eyebrow}</p><div class="gold-line"></div>
      <h2 style="font-size:clamp(30px,4.5vw,64px)">
        ${CONTENT.story.headline}
      </h2>
    </div>
    <div class="reveal right">
      <p style="margin-bottom:20px">
        ${CONTENT.story.para1}
      </p>
      <p style="margin-bottom:28px">
        ${CONTENT.story.para2}
      </p>
      <a class="btn ghost" onclick="go('about',event)">The Studio</a>
    </div>
  </div>
</section>

<section>
  <div class="wrap grid2">
    <div class="collage reveal left">
      ${CONTENT.homepage && CONTENT.homepage.collageImage1
        ? `<div class="art photo a1"><img class="art-img" src="${CONTENT.homepage.collageImage1}" alt="" loading="lazy" decoding="async"><span class="frame"></span></div>`
        : `<div class="art e a1"><span class="cal ar">Allah</span><span class="frame"></span></div>`}
      ${CONTENT.homepage && CONTENT.homepage.collageImage2
        ? `<div class="art photo a2"><img class="art-img" src="${CONTENT.homepage.collageImage2}" alt="" loading="lazy" decoding="async"><span class="frame"></span></div>`
        : `<div class="art g a2"><span class="cal ar">Nur</span><span class="frame"></span></div>`}
    </div>
    <div class="reveal right">
      <p class="eyebrow">${CONTENT.studioSection.eyebrow}</p><div class="gold-line"></div>
      <h2 style="font-size:clamp(28px,4vw,54px)">
        ${CONTENT.studioSection.headline}
      </h2>
      <p style="margin:20px 0 30px">
        ${CONTENT.studioSection.body}
      </p>
      <div class="round-arrow" onclick="go('shop')">→</div>
    </div>
  </div>
</section>

<div>
  <div class="pillar reveal">
    <div class="pillar-icon" aria-hidden="true">
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="20" stroke="rgba(224,177,89,.3)" stroke-width="1.5"/>
        <path d="M24 10 L24 24 L33 33" stroke="var(--gold)" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
          <animateTransform attributeName="transform" type="rotate" values="0 24 24;360 24 24" dur="12s" repeatCount="indefinite"/>
        </path>
        <circle cx="24" cy="24" r="2.5" fill="var(--gold)"/>
      </svg>
    </div>
    <div><h3>${CONTENT.pillars[0].title}</h3><p class="pdesc" style="margin-top:8px">${CONTENT.pillars[0].desc}</p></div>
    <a class="btn-link" onclick="go('about',event)">Learn More →</a>
  </div>
  <div class="pillar dark reveal">
    <div class="pillar-icon" aria-hidden="true">
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="10" y="14" width="28" height="22" rx="4" stroke="rgba(255,255,255,.4)" stroke-width="1.5"/>
        <rect x="16" y="20" width="16" height="10" rx="2" stroke="rgba(224,177,89,.8)" stroke-width="1.5">
          <animate attributeName="opacity" values="1;.4;1" dur="3s" repeatCount="indefinite"/>
        </rect>
        <line x1="24" y1="8" x2="24" y2="14" stroke="rgba(255,255,255,.4)" stroke-width="1.5" stroke-linecap="round"/>
        <line x1="24" y1="36" x2="24" y2="42" stroke="rgba(255,255,255,.4)" stroke-width="1.5" stroke-linecap="round"/>
        <line x1="8" y1="25" x2="10" y2="25" stroke="rgba(255,255,255,.4)" stroke-width="1.5" stroke-linecap="round"/>
        <line x1="38" y1="25" x2="40" y2="25" stroke="rgba(255,255,255,.4)" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    </div>
    <div>
      <h3>${CONTENT.pillars[1].title}</h3>
      <p class="pdesc" style="margin-top:16px">${CONTENT.pillars[1].desc}</p>
    </div>
    <a class="btn gold" onclick="go('about',event)">Learn More</a>
  </div>
  <div class="pillar reveal">
    <div class="pillar-icon" aria-hidden="true">
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 36 C14 24 20 14 24 10 C28 14 34 24 34 36" stroke="rgba(224,177,89,.5)" stroke-width="1.5" fill="none" stroke-linecap="round"/>
        <path d="M18 28 Q24 22 30 28" stroke="var(--gold)" stroke-width="2" fill="none" stroke-linecap="round">
          <animate attributeName="d" values="M18 28 Q24 22 30 28;M18 30 Q24 18 30 30;M18 28 Q24 22 30 28" dur="4s" repeatCount="indefinite"/>
        </path>
        <circle cx="24" cy="36" r="3" fill="var(--gold)" opacity=".6"/>
      </svg>
    </div>
    <div><h3>${CONTENT.pillars[2].title}</h3><p class="pdesc" style="margin-top:8px">${CONTENT.pillars[2].desc}</p></div>
    <a class="btn-link" onclick="go('about',event)">Learn More →</a>
  </div>
  <div class="pillar reveal">
    <div class="pillar-icon" aria-hidden="true">
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M24 10 L27 20 L38 20 L29 27 L32 38 L24 31 L16 38 L19 27 L10 20 L21 20 Z" stroke="rgba(224,177,89,.6)" stroke-width="1.4" fill="rgba(224,177,89,.06)">
          <animate attributeName="opacity" values="1;.5;1" dur="2.8s" repeatCount="indefinite"/>
          <animateTransform attributeName="transform" type="scale" values="1 1;1.06 1.06;1 1" dur="2.8s" additive="sum" repeatCount="indefinite"/>
        </path>
        <circle cx="24" cy="24" r="4" fill="rgba(224,177,89,.22)"/>
      </svg>
    </div>
    <div><h3>${CONTENT.pillars[3].title}</h3><p class="pdesc" style="margin-top:8px">${CONTENT.pillars[3].desc}</p></div>
    <a class="btn-link" onclick="go('about',event)">Learn More →</a>
  </div>
</div>

<section>
  <div class="wrap">
    <div class="stats stagger reveal">
      ${statsHTML()}
    </div>
  </div>
</section>

<section class="rv-section" style="background:var(--stone)">
  <div class="wrap">
    <div class="sec-head reveal" style="text-align:center">
      <p class="eyebrow">${CONTENT.reviewsSection.eyebrow}</p>
      <div class="gold-line"></div>
      <h2>${CONTENT.reviewsSection.headline}</h2>
    </div>
    ${saStatsBarHTML()}
    <div class="rv-grid desktop-grid">
      ${REVIEWS.slice(0,3).map((r,i)=>reviewCard(r,i)).join('')}
    </div>
    <div class="rv-more desktop-more stagger reveal" style="margin-top:clamp(30px,4vw,60px)">
      ${REVIEWS.slice(3,6).map((r,i)=>reviewCard(r,i+3)).join('')}
    </div>
  </div>
</section>

<section>
  <div class="wrap news reveal">
    <div class="grid2">
      <div class="txt">
        <p class="eyebrow" style="color:var(--gold)">${CONTENT.newsletter.eyebrow}</p>
        <h2>${CONTENT.newsletter.headline1}<br><span class="g">${CONTENT.newsletter.headline2}</span></h2>
        <p style="opacity:.7;margin-top:16px">
          ${CONTENT.newsletter.subtext}
        </p>
        <form class="nl-form" onsubmit="return nlSubmit(event)">
          <input type="email" placeholder="Your email address" required>
          <button>Join</button>
        </form>
        <p class="nl-ok" id="nlok">Welcome to the studio ✦ Check your inbox.</p>
      </div>
    </div>
  </div>
</section>

<section>
  <div class="wrap">
    <p class="ig-head reveal">${CONTENT.instagramHandle}</p>
    <div class="ig-strip stagger reveal">
      ${(CONTENT.homepage && CONTENT.homepage.instagramImages && CONTENT.homepage.instagramImages.length
        ? CONTENT.homepage.instagramImages.map((img,i)=>`
            <div class="art photo" onclick="openLB('','photo','${img}')">
              <img class="art-img" src="${img}" alt="" loading="lazy" decoding="async">
              <span class="frame"></span>
            </div>
          `)
        : STYLES.map((s,i)=>`
            <div class="art ${s}" onclick="openLB('${ARWORDS[i]}','${s}')">
              <span class="cal ar">${ARWORDS[i]}</span><span class="frame"></span>
            </div>
          `)
      ).join('')}
    </div>
  </div>
</section>
`;

// shop page
PAGES.shop = () => `
<section class="phero">
  <div class="wrap">
    <div class="breadcrumb"><a onclick="go('home')">Home</a> / Shop</div>
    <p class="eyebrow">${CONTENT.shopPage.eyebrow}</p><h1>${CONTENT.shopPage.headline}</h1>
    <p class="lead">
      ${CONTENT.shopPage.lead}
    </p>
    <span class="pc ar">H</span>
  </div>
</section>
<section style="padding-top:0">
  <div class="wrap">
    <div id="shopWrap"></div>
  </div>
</section>`;

function emptyStateHTML(context) {
  if (context === 'shop') {
    return '<div class="empty-state" style="grid-column:1/-1">'
      + '<svg class="es-illustration" viewBox="0 0 200 180" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'
      + '<rect x="30" y="50" width="140" height="100" rx="12" fill="rgba(224,177,89,.08)" stroke="rgba(224,177,89,.3)" stroke-width="1.5"/>'
      + '<rect x="52" y="32" width="96" height="70" rx="8" fill="rgba(8,115,99,.06)" stroke="rgba(8,115,99,.2)" stroke-width="1.5"/>'
      + '<circle cx="100" cy="95" r="22" fill="rgba(224,177,89,.12)" stroke="rgba(224,177,89,.4)" stroke-width="1.5"/>'
      + '<path d="M92 95 L98 101 L110 89" stroke="rgba(8,115,99,.5)" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>'
      + '</svg>'
      + '<div class="es-title">No pieces match your search</div>'
      + '<div class="es-sub">Try a different filter, adjust the price range, or browse all collections.</div>'
      + '<div class="es-actions">'
      + '<button class="btn emerald" onclick="setFilter(\'All\');setSearch(\'\');var inp=document.getElementById(\'shopSearchInput\');if(inp)inp.value=\'\'">Browse All Pieces</button>'
      + '<button class="btn ghost" onclick="shopFilter=\'All\';shopSearch=\'\';shopPriceMax=999999;shopShown=8;renderShop()">Clear Filters</button>'
      + '</div></div>';
  }
  return '';
}

// render shop
function renderShop(){
  const wrap = document.getElementById('shopWrap');
  if (!wrap) return;

  const activeEl = document.activeElement;
  const wasSearchFocused = activeEl && activeEl.id === 'shopSearchInput';
  const selStart = wasSearchFocused ? activeEl.selectionStart : null;
  const suggElBefore = document.getElementById('shopSugg');
  const suggWasOpen = suggElBefore && suggElBefore.classList.contains('show');

  let list = PRODUCTS.filter(p=> shopFilter==="All" || p.cat===shopFilter);
  if (shopSearch) {
    const q = shopSearch.toLowerCase();
    list = list.filter(p=>
      p.name.toLowerCase().includes(q) ||
      p.cat.toLowerCase().includes(q)
    );
  }
  if (shopPriceMax < 999999) list = list.filter(p => p.price <= shopPriceMax);
  if (shopSort==="low")    list = [...list].sort((a,b)=>a.price-b.price);
  if (shopSort==="high")   list = [...list].sort((a,b)=>b.price-a.price);
  if (shopSort==="rating") list = [...list].sort((a,b)=>b.rating-a.rating);

  const total = list.length;
  const shown = list.slice(0, shopShown);
  const maxP   = Math.max(...PRODUCTS.map(p=>p.price), 100);
  const priceV = shopPriceMax >= 999999 ? maxP : shopPriceMax;

  wrap.innerHTML = `
    <div class="toolbar">
      <div class="filters">
        <button class="chip ${shopFilter==='All'?'active':''}"
                onclick="setFilter('All')">All</button>
        ${CATS.map(c=>
          `<button class="chip ${shopFilter===c?'active':''}"
                  onclick="setFilter('${c}')">${c}</button>`
        ).join('')}
      </div>
      <div class="tools-right">
        <<div class="price-range-wrap" title="Max price filter">
          <span class="prl">≤ ${money(priceV)}</span>
          <input type="range" min="0" max="${maxP}" step="10" value="${priceV}"
         oninput="this.previousElementSibling.textContent='≤ '+('${(THEME.currencyPrefix||'SAR')} '+(+this.value))"
         onchange="setPriceMax(+this.value)">
          </div>
        <div class="search-wrap">
          <div class="search-box">
            <span>⌕</span>
            <input placeholder="Search pieces..."
                   id="shopSearchInput"
                   value="${shopSearch}"
                   oninput="setSearch(this.value);showSearchSugg(this.value)"
                   onblur="setTimeout(hideSearchSugg,180)"
                   autocomplete="off">
          </div>
          <div class="search-suggestions" id="shopSugg"></div>
        </div>
        <select class="sortsel" onchange="setSort(this.value)">
          <option value="featured" ${shopSort==='featured'?'selected':''}>Featured</option>
          <option value="low"      ${shopSort==='low'?'selected':''}>Price: Low–High</option>
          <option value="high"     ${shopSort==='high'?'selected':''}>Price: High–Low</option>
          <option value="rating"   ${shopSort==='rating'?'selected':''}>Top Rated</option>
        </select>
      </div>
    </div>
    <p class="count-note">Showing ${shown.length} of ${total} pieces</p>
    <div class="grid3 stagger in">
      ${shown.map(card).join('') || emptyStateHTML('shop')}
    </div>
    ${shopShown < total
      ? `<div class="center"><button class="btn" onclick="loadMore()">Load More</button></div>`
      : ''
    }
  `;

  if (wasSearchFocused) {
    const inp = document.getElementById('shopSearchInput');
    if (inp) {
      inp.focus();
      if (selStart !== null) inp.setSelectionRange(selStart, selStart);
      if (suggWasOpen) showSearchSugg(inp.value);
    }
  }
}

function setFilter(c){ shopFilter=c; shopShown=8; renderShop(); }
function setSort(s){ shopSort=s; renderShop(); }
function setSearch(v){ shopSearch=v; shopShown=8; renderShop(); }
function setPriceMax(v){ shopPriceMax=v||999999; shopShown=8; renderShop(); }
function loadMore(){ shopShown+=4; renderShop(); }

function showSearchSugg(q) {
  const el = document.getElementById('shopSugg');
  if (!el) return;
  if (!q) { hideSearchSugg(); return; }
  const matches = PRODUCTS.filter(p =>
    p.name.toLowerCase().includes(q.toLowerCase()) ||
    p.cat.toLowerCase().includes(q.toLowerCase())
  ).slice(0,5);
  if (!matches.length) {
    el.innerHTML = `<div class="ss-empty">No results for "${q}"</div>`;
  } else {
    el.innerHTML = matches.map(p=>`
      <div class="ss-item" onmousedown="go('product-${p.id}')">
        ${p.image
          ? `<img class="ss-thumb-img" src="${p.image}" alt="${p.name}" loading="lazy" decoding="async">`
          : `<div class="ss-thumb ss-thumb-noimg" style="background:linear-gradient(135deg,var(--emerald-deep),var(--emerald))"></div>`
        }
        <div class="ss-info">
          <div class="ss-name">${p.name}</div>
          <div class="ss-cat">${p.cat}</div>
        </div>
        <div class="ss-price">${money(p.price)}</div>
      </div>`).join('');
  }
  el.classList.add('show');
}
function hideSearchSugg() {
  const inp = document.getElementById('shopSearchInput');
  if (inp && document.activeElement === inp) return; // still typing — ignore phantom blur
  const el = document.getElementById('shopSugg');
  if (el) el.classList.remove('show');
}

/* installGuideHTML() removed — replaced by full installationVideoSectionHTML() below-fold section */

// ---- PRODUCT PAGE ----
PAGES.product = (id) => {
  const p = PRODUCTS.find(x => x.id == id) || PRODUCTS[0];
  const related = PRODUCTS.filter(x => x.cat === p.cat && x.id !== p.id).slice(0,3);
  const thumbStyles = [p.style, ...STYLES.filter(s => s !== p.style)].slice(0,4);
  const galleryImages = (p.images && p.images.length) ? p.images : [p.image, p.image2, p.image3].filter(Boolean);
  _pdpImages = galleryImages;

  const videoBlock = '';

  return `
<section style="padding-top:clamp(120px,16vw,180px)">
  <div class="wrap">
    <div class="breadcrumb"><a onclick="go('home')">Home</a> / <a onclick="shopFilter='${p.cat}';go('shop')">${p.cat}</a> / ${p.name}</div>
    <div class="pdp">
      <div>
        <div class="gallery-main ${galleryImages.length?'has-photo':''}" id="galMain"
             ${galleryImages.length ? `onclick="openPhotoLB(_pdpImages,lbIndex)"` : `onclick="toggleZoom(this)"`}>
          ${galleryImages.length
            ? `<div class="art photo"><img class="art-img gallery-main-img" src="${galleryImages[0]}" alt="${p.name}" loading="eager" decoding="async" fetchpriority="high"><span class="frame"></span></div>`
            : artTile(p)}
          ${galleryImages.length > 1 ? `
          <button class="gal-arrow gal-arrow-prev" aria-label="Previous image" onclick="event.stopPropagation();galleryNavStep(-1)">&#8249;</button>
          <button class="gal-arrow gal-arrow-next" aria-label="Next image" onclick="event.stopPropagation();galleryNavStep(1)">&#8250;</button>
          <div class="gal-counter" aria-live="polite"><span id="galCountCur">1</span> / ${galleryImages.length}</div>
          ` : ''}
        </div>
        ${galleryImages.length > 1 ? `
        <div class="thumbs" id="galThumbs">
          ${galleryImages.map((img,i)=>`
            <div class="art photo ${i===0?'active':''}" onclick="swapMainPhoto('${img}',this)">
              <img class="art-img" src="${img}" alt="${p.name} view ${i+1}" loading="${i===0?'eager':'lazy'}" decoding="async">
            </div>
          `).join('')}
        </div>` : (galleryImages.length === 0 ? `
        <div class="thumbs">
          ${thumbStyles.map((s,i)=>`
            <div class="art ${s} ${i===0?'active':''}" onclick="swapMain('${s}','${p.ar}',this)">
              <span class="cal ar" lang="ar" aria-label="${p.ar}">${p.ar}</span>
            </div>
          `).join('')}
        </div>` : '')}
        ${videoBlock}
      </div>
      <div class="pdp-info">
        <p class="eyebrow">${p.cat}</p>
        <h1>${p.name}</h1>
        <div class="stars">${stars(p.rating)}</div>
        <div class="pdp-price">${money(p.price)}${p.was?`<span class="was">${money(p.was)}</span>`:''}</div>

        ${p.colors && p.colors.length ? `
        <div class="variant-group">
          <div class="vlabel">Color: <span id="colorName">${p.colors[0].name}</span></div>
          <div class="vopts">
            ${p.colors.map((c,i)=>`
              <button class="vopt swatch ${i===0?'active':''}" style="background:${c.hex}"
                onclick="pickColor(this,${JSON.stringify(c.image||'').replace(/"/g,'&quot;')},${JSON.stringify(c.name).replace(/"/g,'&quot;')})"
                title="${c.name}"></button>
            `).join('')}
          </div>
        </div>` : ''}

        ${p.sizes ? `
        <div class="variant-group">
          <div class="vlabel">Size</div>
          <div class="vopts">
            ${p.sizes.split(',').map((s,i)=>`<button class="vopt ${i===0?'active':''}" onclick="pick(this)">${s.trim()}</button>`).join('')}
          </div>
        </div>` : ''}
        <div class="variant-group">
          <div class="vlabel">Quantity</div>
          <div class="qty">
            <button onclick="qtyChg(-1)">−</button>
            <span id="qtyVal">1</span>
            <button onclick="qtyChg(1)">+</button>
          </div>
        </div>

        <div class="checkout-confidence">
          <div class="cc-badge"><div class="cc-icon">🔒</div><div class="cc-text"><span class="cc-title">Secure Payment</span>SSL encrypted checkout</div></div>
          <div class="cc-badge"><div class="cc-icon">🚚</div><div class="cc-text"><span class="cc-title">Fast Shipping</span>Across Saudi Arabia</div></div>
          <div class="cc-badge"><div class="cc-icon">↩</div><div class="cc-text"><span class="cc-title">30-Day Returns</span>Hassle-free guarantee</div></div>
          <div class="cc-badge"><div class="cc-icon">💬</div><div class="cc-text"><span class="cc-title">WhatsApp Support</span>Chat with us anytime</div></div>
        </div>

        <div class="sticky-cart">
          <button class="btn emerald" onclick="addToCart('${p.id}', +document.getElementById('qtyVal').textContent)">
            Add to Cart — ${money(p.price)}
          </button>
        </div>

        <div class="delivery-badges">
          <div class="del-badge"><span class="db-icon">🇸🇦</span>Saudi Arabia Delivery</div>
          <div class="del-badge"><span class="db-icon">⚡</span>Fast Shipping</div>
          <div class="del-badge"><span class="db-icon">↩</span>Easy Returns</div>
          <div class="del-badge"><span class="db-icon">💬</span>WhatsApp Support</div>
        </div>

        ${pdpFeaturesHTML(p)}
        ${pdpFaqsHTML(p)}
      </div>
    </div>
  </div>
</section>
${pdpBelowFoldSections(p)}
${recentlyViewedHTML(p.id)}
${related.length ? `
<section style="background:var(--stone)">
  <div class="wrap">
    <div class="sec-head reveal">
      <p class="eyebrow">You May Also Like</p><div class="gold-line"></div>
      <h2>Related Pieces</h2>
    </div>
    <div class="grid3 stagger reveal">${related.map(card).join('')}</div>
  </div>
</section>` : ''}
`;
};

// ---- COLLECTIONS PAGE ----
PAGES.collections = () => `
<section class="phero">
  <div class="wrap">
    <div class="breadcrumb"><a onclick="go('home')">Home</a> / Collections</div>
    <p class="eyebrow">${CONTENT.collectionsPage.eyebrow}</p><h1>${CONTENT.collectionsPage.headline}</h1>
    <p class="lead">${CONTENT.collectionsPage.lead}</p>
    <span class="pc ar">H</span>
  </div>
</section>
<section style="padding-top:0">
  <div class="wrap">
    <div class="grid2 stagger reveal">
      ${CATS.map((c,i)=>{
        const count = PRODUCTS.filter(p=>p.cat===c).length;
        const style = STYLES[i % STYLES.length];
        const ar = ARWORDS[i % ARWORDS.length];
        const catImg = (CONTENT.categoryImages || []).find(ci => ci.category === c);
        const bg = catImg
          ? `<div class="cbg art photo" style="position:absolute;inset:0;border-radius:14px;aspect-ratio:auto"><img class="art-img" src="${catImg.image}" alt="${c}" loading="lazy" decoding="async"></div>`
          : `<div class="cbg art ${style}" style="position:absolute;inset:0;border-radius:14px;aspect-ratio:auto"></div>`;
        return `
        <div class="coll-banner ${i===0?'coll-wide':''}" onclick="shopFilter='${c}';go('shop')">
          ${bg}
          <span class="car ar">${ar}</span>
          <div>
            <p class="cn">${count} Pieces</p>
            <h3>${c}</h3>
          </div>
          <span class="coll-explore-btn">Explore →</span>
        </div>`;
      }).join('')}
    </div>
  </div>
</section>
`;

// ---- WISHLIST PAGE ----
PAGES.wishlist = () => {
  const items = PRODUCTS.filter(p => WISHLIST.includes(String(p.id)));
  return `
<section class="phero">
  <div class="wrap">
    <div class="breadcrumb"><a onclick="go('home')">Home</a> / Wishlist</div>
    <p class="eyebrow">Saved Pieces</p>
    <h1>Your Wishlist</h1>
    <span class="pc ar">H</span>
  </div>
</section>
<section style="padding-top:0">
  <div class="wrap">
    ${!items.length
      ? '<div class="empty-state">'
        + '<svg class="es-illustration" viewBox="0 0 200 180" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'
        + '<path d="M100 145 C100 145 42 108 42 72 C42 55 55 44 68 44 C78 44 88 49 100 62 C112 49 122 44 132 44 C145 44 158 55 158 72 C158 108 100 145 100 145Z" fill="rgba(255,92,77,.10)" stroke="rgba(255,92,77,.35)" stroke-width="1.8" stroke-linejoin="round"/>'
        + '<path d="M78 72 C78 66 82 62 88 62" stroke="rgba(255,92,77,.4)" stroke-width="2" stroke-linecap="round"/>'
        + '</svg>'
        + '<div class="es-title">Your wishlist is empty</div>'
        + '<div class="es-sub">Save pieces you love — tap the heart icon on any product to add it here.</div>'
        + '<div class="es-actions">'
        + '<button class="btn emerald" onclick="go(\'shop\')">Browse Pieces</button>'
        + '<button class="btn ghost" onclick="go(\'collections\')">View Collections</button>'
        + '</div></div>'
      : `<div class="grid3 stagger in">${items.map(card).join('')}</div>`
    }
  </div>
</section>`;
};

// ---- COMPARE PAGE ----
PAGES.compare = () => {
  if (!COMPARE.length) {
    return `
<section class="phero">
  <div class="wrap">
    <div class="breadcrumb"><a onclick="go('home')">Home</a> / Compare</div>
    <p class="eyebrow">Side by Side</p><h1>Compare Pieces</h1>
    <span class="pc ar">H</span>
  </div>
</section>
<section style="padding-top:0">
  <div class="wrap">
    <div class="wl-empty">
      <p style="opacity:.6">Select two pieces to compare them. Use the Compare button on any product card.</p>
      <button class="btn emerald" onclick="go('shop')" style="margin-top:20px">Browse Pieces</button>
    </div>
  </div>
</section>`;
  }
  const cols = COMPARE.slice(0,2);
  const rows = [
    { label:'Price',       get: p => money(p.price) + (p.was ? ` <span style="text-decoration:line-through;opacity:.45;font-size:12px;margin-left:6px">${money(p.was)}</span>` : '') },
    { label:'Rating',      get: p => '★'.repeat(p.rating)+'☆'.repeat(5-p.rating) },
    { label:'Category',    get: p => p.cat },
    { label:'Art Style',   get: p => p.style.toUpperCase() },
    { label:'Arabic Word', get: p => `<span class="ar" style="font-size:22px">${p.ar}</span>` },
    { label:'Sizes',       get: p => p.sizes || '40×40cm, 60×60cm, 80×80cm' },
  ];
  return `
<section class="phero">
  <div class="wrap">
    <div class="breadcrumb"><a onclick="go('home')">Home</a> / Compare</div>
    <p class="eyebrow">Side by Side</p><h1>Compare Pieces</h1>
    <span class="pc ar">H</span>
  </div>
</section>
<section style="padding-top:0">
  <div class="wrap">
    <div class="compare-grid">
      ${cols.map(p=>`
        <div class="compare-col">
          <div class="c-art art ${p.image?'photo':p.style}">
            ${p.image
              ? `<img class="art-img" src="${p.image}" alt="${p.name}" loading="lazy" decoding="async">`
              : `<span class="cal ar" lang="ar" aria-label="${p.ar}">${p.ar}</span>`}
            <span class="frame"></span>
          </div>
          <h3 style="margin-top:18px;font-size:clamp(18px,2.5vw,26px)">${p.name}</h3>
          <p style="color:var(--emerald-deep);font-size:20px;font-weight:500;margin:8px 0">${money(p.price)}</p>
          <button class="btn emerald" onclick="addToCart('${p.id}')" style="margin-top:10px;width:100%;justify-content:center">Add to Cart</button>
        </div>
      `).join('')}
    </div>
    <table class="compare-tbl">
      <thead>
        <tr>
          <th>Feature</th>
          ${cols.map(p=>`<th style="font-family:var(--f-display);font-size:14px;font-weight:700;text-transform:uppercase">${p.name}</th>`).join('')}
        </tr>
      </thead>
      <tbody>
        ${rows.map(r=>`
          <tr>
            <td>${r.label}</td>
            ${cols.map(p=>`<td>${r.get(p)}</td>`).join('')}
          </tr>
        `).join('')}
      </tbody>
    </table>
    <div style="text-align:center;margin-top:32px">
      <button class="btn ghost" onclick="clearCompare();go('shop')">Clear &amp; Browse More</button>
    </div>
  </div>
</section>`;
};

// ---- ABOUT PAGE ----
PAGES.about = () => `
<section class="phero">
  <div class="wrap">
    <div class="breadcrumb"><a onclick="go('home')">Home</a> / About</div>
    <p class="eyebrow">${CONTENT.about.eyebrow}</p>
    <h1>${CONTENT.about.headline}</h1>
    <p class="lead">${CONTENT.about.lead}</p>
    <span class="pc ar">H</span>
  </div>
</section>
<section style="padding-top:0">
  <div class="wrap">
    <div class="reveal">
      <p class="eyebrow">${CONTENT.about.since_label}</p><div class="gold-line"></div>
      <h2 style="font-size:clamp(28px,4vw,54px)">${CONTENT.about.subheadline}</h2>
      <p style="margin:20px 0">
        ${CONTENT.about.para1}
      </p>
      <p style="opacity:.85">
        ${CONTENT.about.para2}
      </p>
    </div>
  </div>
</section>
<section style="background:var(--stone)">
  <div class="wrap">
    <div class="stats stagger reveal">
      ${statsHTML()}
    </div>
  </div>
</section>
<div>
  <div class="pillar reveal">
    <span class="num">01</span>
    <h3>Our Materials</h3>
    <p class="pdesc">Premium acrylic, precision-cut and finished to a crystal-clear, high-gloss shine.</p>
  </div>
  <div class="pillar dark reveal">
    <span class="num">02</span>
    <div>
      <h3>Our Process</h3>
      <p class="pdesc" style="margin-top:16px">Sketch, gild, seal, and frame — every piece passes through the same four hands.</p>
    </div>
  </div>
  <div class="pillar reveal">
    <span class="num">03</span>
    <h3>Our Promise</h3>
    <p class="pdesc">Every piece is inspected by hand before it ever reaches your door.</p>
  </div>
</div>
`;

// ---- CONTACT PAGE ----
PAGES.contact = () => `
<section class="phero">
  <div class="wrap">
    <div class="breadcrumb"><a onclick="go('home')">Home</a> / Contact</div>
    <p class="eyebrow">${CONTENT.contact.eyebrow}</p><h1>${CONTENT.contact.headline}</h1>
    <p class="lead">${CONTENT.contact.lead}</p>
    <span class="pc ar">H</span>
  </div>
</section>
<section style="padding-top:0">
  <div class="wrap grid2">
    <div class="reveal left">
      <form class="form-grid" onsubmit="return formSubmit(event,'contactOk')">
        <div class="field"><label>Name</label><input type="text" id="contactName" required></div>
        <div class="field"><label>Email</label><input type="email" id="contactEmail" required></div>
        <div class="field full"><label>Subject</label><input type="text" id="contactSubject" required></div>
        <div class="field full"><label>Message</label><textarea id="contactMessage" required></textarea></div>
        <div class="field full">
          <button class="btn emerald" type="submit">Send Message</button>
          <div class="form-ok" id="contactOk">${CONTENT.contact.confirmation}</div>
        </div>
      </form>
    </div>
    <div class="reveal right" style="display:flex;flex-direction:column;gap:20px">
      <div class="info-card"><div class="ic">✉</div><h3>Email</h3><p style="opacity:.75">${CONTENT.contact.email}</p></div>
      <div class="info-card"><div class="ic">☏</div><h3>Phone</h3><p style="opacity:.75">${CONTENT.contact.phone}</p></div>
      <div class="info-card"><div class="ic">⚑</div><h3>Studio</h3><p style="opacity:.75">${CONTENT.contact.address}</p></div>
    </div>
  </div>
</section>
`;

// ---- GALLERY PAGE ----
PAGES.gallery = () => `
<section class="phero">
  <div class="wrap">
    <div class="breadcrumb"><a onclick="go('home')">Home</a> / Gallery</div>
    <p class="eyebrow">${CONTENT.galleryPage.eyebrow}</p><h1>${CONTENT.galleryPage.headline}</h1>
    <p class="lead">${CONTENT.galleryPage.lead}</p>
    <span class="pc ar">H</span>
  </div>
</section>
<section style="padding-top:0">
  <div class="wrap">
    <div class="masonry reveal in">
      ${(CONTENT.gallery && CONTENT.gallery.length
        ? CONTENT.gallery.map(g=>`
            <div class="art photo" onclick="openLB('${g.ar||''}','photo','${g.image}')">
              <img class="art-img" src="${g.image}" alt="${g.ar||''}" loading="lazy" decoding="async">
              <span class="frame"></span>
            </div>
          `)
        : ARWORDS.map((w,i)=>{
            const s = STYLES[i % STYLES.length];
            return `<div class="art ${s}" onclick="openLB('${w}','${s}')"><span class="cal ar">${w}</span><span class="frame"></span></div>`;
          })
      ).join('')}
    </div>
  </div>
</section>
`;

// ---- FAQS PAGE ----
PAGES.faqs = () => `
<section class="phero">
  <div class="wrap">
    <div class="breadcrumb"><a onclick="go('home')">Home</a> / FAQs</div>
    <p class="eyebrow">${CONTENT.faqPage.eyebrow}</p><h1>${CONTENT.faqPage.headline}</h1>
    <span class="pc ar">H</span>
  </div>
</section>
<section style="padding-top:0">
  <div class="wrap policy">
    ${PFAQ_EXTRA.map((f,i)=>`
      <div class="acc-item ${i===0?'open':''}">
        <button class="acc-q" onclick="toggleAcc(this)"><span>${f.q}</span><span class="ico">+</span></button>
        <div class="acc-a"><p>${f.a}</p></div>
      </div>
    `).join('')}
  </div>
</section>
`;

// ---- REVIEWS PAGE ----
PAGES.reviews = () => `
<section class="phero">
  <div class="wrap">
    <div class="breadcrumb"><a onclick="go('home')">Home</a> / Reviews</div>
    <p class="eyebrow">${CONTENT.reviewsPage.eyebrow}</p><h1>${CONTENT.reviewsPage.headline}</h1>
    <span class="pc ar">H</span>
  </div>
</section>
<section style="padding-top:0">
  <div class="wrap">
    <div class="rev-summary reveal">
      <div class="big">${CONTENT.reviewsPage.score}</div>
      <div class="stars" style="font-size:20px">${stars(5)}</div>
      <p style="opacity:.6;margin-top:10px">${CONTENT.reviewsPage.countLabel}</p>
    </div>
    ${saStatsBarHTML()}
    <div class="rv-grid" style="margin-top:clamp(40px,5vw,80px)">
      ${REVIEWS.slice(0,3).map((r,i)=>reviewCard(r,i)).join('')}
    </div>
    <div class="rv-more stagger reveal" style="margin-top:clamp(30px,4vw,60px)">
      ${REVIEWS.slice(3).map((r,i)=>reviewCard(r,i+3)).join('')}
    </div>
  </div>
</section>
`;

// ---- TRACK ORDER PAGE ----
PAGES.track = () => `
<section class="phero">
  <div class="wrap">
    <div class="breadcrumb"><a onclick="go('home')">Home</a> / Track Order</div>
    <p class="eyebrow">${CONTENT.trackPage.eyebrow}</p><h1>${CONTENT.trackPage.headline}</h1>
    <span class="pc ar">H</span>
  </div>
</section>
<section style="padding-top:0">
  <div class="wrap policy">
    <form class="form-grid" onsubmit="return trackSubmit(event)">
      <div class="field"><label>Order Number</label><input type="text" placeholder="e.g. AL-HURUF-10234" required></div>
      <div class="field"><label>Email</label><input type="email" required></div>
      <div class="field full"><button class="btn emerald" type="submit">Track Order</button></div>
    </form>
    <div id="trackResult" style="display:none;margin-top:30px">
      <div class="info-card">
        <h3>Order In Transit</h3>
        <p style="opacity:.75;margin-top:10px">
          Your piece has been gilded, framed, and is on its way.
          Estimated delivery in 3–5 business days.
        </p>
      </div>
    </div>
  </div>
</section>
`;

// other pages (collections, product, about, contact, faqs, reviews, gallery, track, shipping, returns, privacy, terms)
const POLICIES = {
  shipping: { t:"Shipping Policy", b: CONTENT.policies ? CONTENT.policies.shipping : "" },
  returns:  { t:"Returns & Refunds", b: CONTENT.policies ? CONTENT.policies.returns  : "" },
  privacy:  { t:"Privacy Policy",   b: CONTENT.policies ? CONTENT.policies.privacy  : "" },
  terms:    { t:"Terms of Service", b: CONTENT.policies ? CONTENT.policies.terms    : "" }
};

Object.keys(POLICIES).forEach(k=>{
  PAGES[k] = () => `
    <section class="phero">
      <div class="wrap">
        <div class="breadcrumb"><a onclick="go('home')">Home</a> / ${POLICIES[k].t}</div>
        <p class="eyebrow">Legal</p><h1 style="font-size:clamp(34px,6vw,90px)">${POLICIES[k].t}</h1>
      </div>
    </section>
    <section style="padding-top:0">
      <div class="wrap policy reveal in">
        ${POLICIES[k].b}
      </div>
    </section>
  `;
});

// append footer to every page
function footerHTML(){
  const soc = THEME.social;

const socialLink = (url, type, label) => {
  const icons = {
    instagram: `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="3" y="3" width="18" height="18" rx="5"></rect>
        <circle cx="12" cy="12" r="4"></circle>
        <circle cx="17.5" cy="6.5" r="1"></circle>
      </svg>
    `,
    facebook: `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M14 8h3V4h-3c-3.3 0-5 2-5 5v3H6v4h3v5h4v-5h3l1-4h-4V9c0-.7.3-1 1-1z"></path>
      </svg>
    `,
    tiktok: `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M15 4c.5 2.2 1.8 3.5 4 3.7v3.2c-1.5 0-2.8-.4-4-1.1v5.7c0 3.5-2.6 5.5-5.6 5.5-3 0-5.4-2-5.4-5 0-3.2 2.7-5.4 6-5.1v3.2c-1.6-.2-2.8.6-2.8 1.9 0 1.1.9 1.8 2.1 1.8 1.3 0 2.5-.8 2.5-2.8V4H15z"></path>
      </svg>
    `
  };

  return url
    ? `<a href="${url}" target="_blank" rel="noopener noreferrer" aria-label="${label}">${icons[type]}</a>`
    : '';
};
  return `
  <footer>
    <div class="fwm">${THEME.logoText}<span class="dot">.</span></div>
    <div class="fcols">
      <div>
        <h4>Collections</h4>
        ${CATS.map(c=>
          `<a onclick="shopFilter='${c}';go('shop')">${c}</a>`
        ).join('')}
      </div>
      <div>
        <h4>Studio</h4>
        <a onclick="go('about')">About Us</a>

        <a onclick="go('reviews')">Reviews</a>
        <a onclick="go('contact')">Contact</a>
      </div>
      <div>
        <h4>Support</h4>
        <a onclick="go('contact')">Contact</a>
        <a onclick="go('faqs')">FAQs</a>
        <a onclick="go('track')">Track Order</a>
        <a onclick="go('shipping')">Shipping</a>
        <a onclick="go('returns')">Returns</a>
      </div>
    </div>
    <div class="fsoc">
  ${socialLink(soc.instagram, 'instagram', 'Instagram')}
  ${socialLink(soc.facebook, 'facebook', 'Facebook')}
  ${socialLink(soc.tiktok, 'tiktok', 'TikTok')}
</div>
    <div style="margin:24px 0; display:flex; gap:20px; justify-content:center; flex-wrap:wrap; font-size:12px; letter-spacing:.1em; opacity:.6">
      <a onclick="go('privacy')">Privacy</a>
      <a onclick="go('terms')">Terms</a>
      <a onclick="go('shipping')">Shipping</a>
      <a onclick="go('returns')">Returns</a>
    </div>
    <div class="fbot">
      © ${new Date().getFullYear()} ${THEME.footerCopyright}
    </div>
  </footer>`;
}

/* ============ ROUTER ============ */
/* Timed choreography for the luxury calligraphy transition (v10):
     0ms     overlay begins fading to black (500ms, CSS)
     520ms   overlay is fully opaque — route content swapped in
             behind it (never earlier, so the new page can't flash
             through mid-fade)
     520ms+  calligraphy emerges from darkness under soft gold
             light — fade + gentle unblur, no scale-pop, no spin
     ~1900ms a still "hold" beat, like a gallery placard settling
     ~2160ms dissolve begins: the artwork fades outward at the very
             same moment the overlay itself starts fading (700ms,
             CSS), so the piece visually merges into the page
             rather than the curtain simply lifting afterwards
     ~2860ms classes reset, ready for the next navigation           */
let curtainTimers = [];

function go(route, e){
  if (e) e.preventDefault();
  closeNav();
  const curtain = document.getElementById('curtain2');
  if (!curtain || !window.calligTransition) {
    render(route); window.scrollTo(0,0); location.hash='#/'+route; return;
  }

  /* Stop any in-progress animation without firing its callbacks */
  window.calligTransition.stop(true);
  curtainTimers.forEach(clearTimeout);
  curtainTimers = [];

  curtain.classList.remove('is-active','is-leaving');
  void curtain.offsetWidth;
  curtain.classList.add('is-active');

  window.calligTransition.play(
    /* onPageRendered — fires once the overlay is fully opaque */
    function(){ render(route); window.scrollTo(0,0); },
    /* onDone — fires as the dissolve begins, so the overlay's own
       700ms fade (CSS .is-leaving) runs concurrently with the
       artwork dissolving, not after it */
    function(){
      curtain.classList.add('is-leaving');
      curtain.classList.remove('is-active');
      curtainTimers.push(setTimeout(function(){
        curtain.classList.remove('is-leaving');
      }, 720));
    }
  );

  location.hash = '#/' + route;
}

function render(route){
  destroyStickyBar();
  const page = document.getElementById('page');
  let html = '';
  if (route.startsWith('product-')) {
    const id = route.slice('product-'.length);
    trackRecentlyViewed(id);
    html = PAGES.product(id);
  }
  else if (PAGES[route]) {
    html = PAGES[route]();
  }
  else {
    route = 'home';
    html = PAGES.home();
  }
  page.innerHTML = html + footerHTML();

  // Sticky bar for product pages
  if (route.startsWith('product-')) {
    const id = route.slice('product-'.length);
    const p = PRODUCTS.find(x=>x.id==id) || PRODUCTS[0];
    initStickyBar(p);
    setTimeout(initImageZoom, 120);
    setTimeout(initGallerySwipe, 140);
    setTimeout(initMobilePinchZoom, 150);
    // Preload the second gallery image for instant hover-ready state
    if (_pdpImages.length > 1) {
      var pl = document.createElement('link');
      pl.rel = 'preload'; pl.as = 'image'; pl.href = _pdpImages[1];
      document.head.appendChild(pl);
    }
  }

  // Trust line reveal on home
  if (route === 'home') {
    setTimeout(()=>{ const el=document.getElementById('muTrust'); if(el) el.classList.add('is-in'); }, 980);
  }

  // header theme
  const h = document.getElementById('header');
  const lightRoutes = ['home'];
  if (lightRoutes.includes(route)) {
    h.classList.add('light');
  } else {
    h.classList.remove('light');
  }

  // active nav link
  document.querySelectorAll('#nav a').forEach(a=>{
    a.classList.toggle('active',
      a.getAttribute('href') === '#/'+route
    );
  });

  // init sub-components
  if (route === 'shop')  renderShop();
  if (route === 'home')  initSlider();
  if (route === 'home' && window.initHeroCalligraphy) initHeroCalligraphy();
  initReveal();
  initCounts();
  updateWishlistCount();
  renderCompareBar();
  // Mobile review swiper (home + reviews page)
  if (route === 'home' || route === 'reviews') initReviewSwiper();
  // Preload hover images on product-listing pages so first hover is instant
  if (route === 'home' || route === 'shop' || route === 'collections' || route === 'wishlist') {
    preloadCardHoverImages();
  }
  // Installation section step animations
  if (route.startsWith('product-')) {
    setTimeout(initInstallSteps, 80);
  }

  // reset page animation
  const pg = document.getElementById('page');
  pg.style.animation = 'none';
  void pg.offsetWidth;
  pg.style.animation = '';
}

/* ============ REVEAL ON SCROLL ============ */
let revObs;
function initReveal(){
  if (revObs) revObs.disconnect();
  revObs = new IntersectionObserver(entries=>{
    entries.forEach(en=>{
      if (en.isIntersecting){
        en.target.classList.add('in');
        revObs.unobserve(en.target);
      }
    });
  }, { threshold: .12 });
  document.querySelectorAll('.reveal,.reveal-scale,.reveal-up,.reveal-fade').forEach(el=>{
    if (el.getBoundingClientRect().top < window.innerHeight) {
      el.classList.add('in');
    } else {
      revObs.observe(el);
    }
  });
}

/* COUNT UP */
let cntObs;
function initCounts(){
  if (cntObs) cntObs.disconnect();
  cntObs = new IntersectionObserver(entries=>{
    entries.forEach(en=>{
      if (en.isIntersecting){
        countUp(en.target);
        cntObs.unobserve(en.target);
      }
    });
  }, { threshold: .5 });
  document.querySelectorAll('[data-count]').forEach(el=>{
    cntObs.observe(el);
  });
}

function countUp(el){
  const target = +el.dataset.count;
  const suffix = el.dataset.suffix || '';
  let current = 0;
  const step = target / 60;
  const timer = setInterval(()=>{
    current += step;
    if (current >= target) {
      current = target;
      clearInterval(timer);
    }
    el.textContent = Math.floor(current) + suffix;
  }, 22);
}

/* ============ SHOPIFY CART / CHECKOUT ============ */
/*
 * The visual cart is custom, but the source of truth is Shopify's cart.
 * Products need a Shopify product selected in the corresponding theme-editor
 * product block. The Liquid section outputs its first available variant ID.
 */
let _cartBusy = false;

async function syncShopifyCart(openAfterSync=false){
  try {
    const res = await fetch((window.SHOPIFY_CART && SHOPIFY_CART.cartUrl) || '/cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    });
    if (!res.ok) throw new Error('Cart request failed');
    const data = await res.json();

    CART = (data.items || []).map(item => {
      const customId = item.properties && item.properties._alhuruf_product_id
        ? String(item.properties._alhuruf_product_id)
        : null;
      const linked = customId
        ? PRODUCTS.find(x => String(x.id) === customId)
        : null;

      return {
        id: customId || item.key,
        cartKey: item.key,
        variant_id: item.variant_id,
        product_id: item.product_id,
        name: item.product_title || item.title,
        price: Number(item.final_price || item.price || 0) / 100,
        qty: item.quantity,
        image: item.image || (linked && linked.image) || '',
        images: linked && linked.images ? linked.images : (item.image ? [item.image] : []),
        style: linked ? linked.style : 'e',
        ar: linked ? linked.ar : '',
        rating: linked ? linked.rating : 5,
        properties: item.properties || {},
        shopify: true
      };
    });

    updateCart();
    if (openAfterSync) openCart();
    return data;
  } catch (err) {
    console.error('Shopify cart sync failed:', err);
    return null;
  }
}

async function addToCart(id, qty=1){
  const prod = PRODUCTS.find(x => String(x.id) === String(id));
  if (!prod) return;

  if (!prod.variant_id) {
    alert('This product is not connected to a Shopify product yet. Open the theme editor and select its Shopify product.');
    return;
  }

  if (_cartBusy) return;
  _cartBusy = true;

  try {
    const res = await fetch((window.SHOPIFY_CART && SHOPIFY_CART.addUrl) || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{
          id: Number(prod.variant_id),
          quantity: Math.max(1, Number(qty) || 1),
          properties: {
            _alhuruf_product_id: String(prod.id)
          }
        }]
      })
    });

    const result = await res.json().catch(() => ({}));
    if (!res.ok) {
      throw new Error(result.description || result.message || 'Unable to add this product.');
    }

    await syncShopifyCart(true);
  } catch (err) {
    console.error('Shopify add-to-cart failed:', err);
    alert(err.message || 'Could not add this product to the cart. Please try again.');
  } finally {
    _cartBusy = false;
  }
}

async function removeFromCart(id){
  const item = CART.find(x => String(x.id) === String(id));
  if (!item || !item.cartKey) return;

  try {
    const res = await fetch((window.SHOPIFY_CART && SHOPIFY_CART.changeUrl) || '/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ id: item.cartKey, quantity: 0 })
    });
    if (!res.ok) throw new Error('Unable to remove item.');
    await syncShopifyCart();
  } catch (err) {
    console.error('Shopify remove failed:', err);
    alert('Could not remove this item. Please try again.');
  }
}

function updateCart(){
  const count = CART.reduce((sum,x)=>sum + x.qty,0);
  const countEl = document.getElementById('cc');
  if (countEl) countEl.textContent = count;

  const body = document.getElementById('cartBody');
  if (!body) return;

  if (CART.length === 0) {
    body.innerHTML = `
      <div class="cart-empty">
        <p>${THEME.cart.emptyText}</p><br>
        <button class="btn emerald" onclick="closeCart();go('shop')">
          ${THEME.cart.browseLabel}
        </button>
      </div>`;
  } else {
    body.innerHTML = CART.map(item=>`
      <div class="cart-line">
        ${artTile(item)}
        <div class="cl-info">
          <div class="cl-name">${item.name}</div>
          <div class="cl-qty">
            <button onclick="cartQtyChange('${item.id}',-1)">−</button>
            <span>${item.qty}</span>
            <button onclick="cartQtyChange('${item.id}',1)">+</button>
          </div>
          <div class="cl-rm" onclick="removeFromCart('${item.id}')">Remove</div>
        </div>
        <div style="font-weight:500;font-size:14px">${money(item.price * item.qty)}</div>
      </div>
    `).join('');
  }

  const total = CART.reduce((sum,x)=>sum + x.price*x.qty,0);
  const totalEl = document.getElementById('cartTotal');
  if (totalEl) totalEl.textContent = money(total);

  const totalLbl = document.querySelector('.cart-total span:first-child');
  if (totalLbl) totalLbl.textContent = THEME.cart.totalLabel;

  // Shipping estimate & progress bar
  const shipEl = document.getElementById('cartShipEst');
  if (shipEl) {
    const threshold = THEME.freeShippingThreshold || 0;
    const cartSubtotal = CART.reduce((sum,x)=>sum + x.price*x.qty, 0);
    if (threshold > 0 && CART.length) {
      const pct = Math.min(100, Math.round((cartSubtotal / threshold) * 100));
      const remaining2 = threshold - cartSubtotal;
      if (remaining2 > 0) {
        shipEl.innerHTML = '<div class="cart-ship-progress-wrap">'
          + '<div class="csp-label"><span style="font-size:14px">🚚</span> Add <strong>' + money(remaining2) + '</strong> more for free delivery</div>'
          + '<div class="csp-bar"><div class="csp-fill" style="width:' + pct + '%"></div></div>'
          + '</div>';
      } else {
        shipEl.innerHTML = '<div class="csp-free"><span>🎉</span> You\'ve unlocked <strong>free delivery</strong> across Saudi Arabia!</div>';
      }
      shipEl.style.display = 'block';
      shipEl.style.padding = '12px 24px';
    } else if (CART.length) {
      shipEl.innerHTML = '<span style="font-size:16px">🚚</span><span>Free delivery across Saudi Arabia</span>';
      shipEl.style.display = 'flex';
    } else {
      shipEl.style.display = 'none';
    }
  }

  // Suggested products
  const sugWrap = document.getElementById('cartSugWrap');
  const sugItems = document.getElementById('cartSugItems');
  if (sugWrap && sugItems) {
    if (CART.length) {
      const cartIds = new Set(CART.map(x=>String(x.id)));
      const sugs = PRODUCTS.filter(p=>!cartIds.has(String(p.id))).slice(0,4);
      sugItems.innerHTML = sugs.map(p=>`
        <div class="cs-item" onclick="closeCart();go('product-${p.id}')">
          ${p.image
            ? `<img class="cs-art-img" src="${p.image}" alt="${p.name}" loading="lazy" decoding="async">`
            : `<div class="cs-art cs-art-noimg" style="background:linear-gradient(135deg,var(--emerald-deep),var(--emerald))"></div>`
          }
          <div class="cs-name">${p.name}</div>
          <div class="cs-price">${money(p.price)}</div>
        </div>`).join('');
      sugWrap.style.display = 'block';
    } else {
      sugWrap.style.display = 'none';
    }
  }

  // Trust badges in cart footer
  const trustBadgesEl = document.getElementById('cartTrustBadges');
  if (trustBadgesEl) {
    const t = THEME.trust || {};
    if (CART.length) {
      trustBadgesEl.innerHTML = '<div class="ctb-item">✓ ' + (t.badge1||'Premium Acrylic') + '</div>'
        + '<div class="ctb-item">✓ ' + (t.badge3||'Secure Payment') + '</div>'
        + '<div class="ctb-item">✓ ' + (t.badge4||'Fast Delivery Across Saudi Arabia') + '</div>'
        + '<div class="ctb-item">✓ ' + (t.badge5||'Easy Installation') + '</div>';
      trustBadgesEl.style.display = 'grid';
    } else {
      trustBadgesEl.style.display = 'none';
    }
  }
}

async function cartQtyChange(id, delta) {
  const item = CART.find(x => String(x.id) === String(id));
  if (!item || !item.cartKey) return;

  const newQty = Math.max(1, item.qty + delta);
  try {
    const res = await fetch((window.SHOPIFY_CART && SHOPIFY_CART.changeUrl) || '/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ id: item.cartKey, quantity: newQty })
    });
    if (!res.ok) throw new Error('Unable to update quantity.');
    await syncShopifyCart();
  } catch (err) {
    console.error('Shopify quantity update failed:', err);
    alert('Could not update the quantity. Please try again.');
  }
}

function shopifyCheckout(){
  if (!CART.length) {
    alert(THEME.cart.emptyText || 'Your cart is empty.');
    return;
  }
  window.location.href = (window.SHOPIFY_CART && SHOPIFY_CART.checkoutUrl) || '/checkout';
}

function openCart(){
  document.getElementById('cartDrawer').classList.add('open');
  document.getElementById('cartOverlay').classList.add('on');
}

function closeCart(){
  document.getElementById('cartDrawer').classList.remove('open');
  document.getElementById('cartOverlay').classList.remove('on');
}

/* ============ NAV / UI ============ */
function toggleNav(){
  const isOpen = document.getElementById('nav').classList.toggle('open');
  document.getElementById('burger').classList.toggle('open');
  document.body.classList.toggle('nav-open', isOpen);
}
function closeNav(){
  document.getElementById('nav').classList.remove('open');
  document.getElementById('burger').classList.remove('open');
  document.body.classList.remove('nav-open');
}
function toggleAcc(btn){
  btn.parentElement.classList.toggle('open');
}
function pick(btn){
  Array.from(btn.parentElement.children).forEach(b=>b.classList.remove('active'));
  btn.classList.add('active');
}
function qtyChg(delta, elId){
  const el = document.getElementById(elId || 'qtyVal');
  if (!el) return;
  let v = +el.textContent + delta;
  if (v < 1) v = 1;
  el.textContent = v;
}
function toggleZoom(el){
  el.classList.toggle('zoom');
  el.style.cursor = el.classList.contains('zoom') ? 'zoom-out' : 'zoom-in';
}
/* Apple-style smooth image zoom on product gallery */
function initImageZoom() {
  if (THEME.features && THEME.features.enableImageZoom === false) return;
  var el = document.querySelector('.gallery-main.has-photo');
  if (!el) return;
  var img = el.querySelector('.art-img');
  if (!img) return;
  var isZoomed = false;
  var cursorX = 50, cursorY = 50;
  el.addEventListener('mousemove', function(e) {
    var rect = el.getBoundingClientRect();
    cursorX = ((e.clientX - rect.left) / rect.width * 100).toFixed(2);
    cursorY = ((e.clientY - rect.top) / rect.height * 100).toFixed(2);
    if (isZoomed) {
      img.style.transformOrigin = cursorX + '% ' + cursorY + '%';
    }
  });
  el.addEventListener('mouseleave', function() {
    if (isZoomed) {
      isZoomed = false;
      el.style.cursor = 'zoom-in';
      img.style.transform = 'translateZ(0)';
      img.style.transition = 'transform .38s cubic-bezier(.22,1,.36,1)';
      img.style.transformOrigin = '';
    }
  });
  el.addEventListener('click', function(e) {
    e.stopPropagation();
    isZoomed = !isZoomed;
    if (isZoomed) {
      el.style.cursor = 'zoom-out';
      img.style.transformOrigin = cursorX + '% ' + cursorY + '%';
      img.style.transition = 'transform .38s cubic-bezier(.22,1,.36,1)';
      img.style.transform = 'translateZ(0) scale(2.4)';
    } else {
      el.style.cursor = 'zoom-in';
      img.style.transition = 'transform .38s cubic-bezier(.22,1,.36,1)';
      img.style.transform = 'translateZ(0)';
    }
  });
}
function swapMain(style, ar, thumb){
  const main = document.getElementById('galMain');
  main.innerHTML = `<div class="art ${style}">
    <span class="cal ar">${ar}</span><span class="frame"></span>
  </div>`;
  Array.from(thumb.parentElement.children)
       .forEach(t => t.classList.remove('active'));
  thumb.classList.add('active');
}
function pickColor(btn, img, name){
  Array.from(btn.parentElement.children).forEach(b=>b.classList.remove('active'));
  btn.classList.add('active');
  const nameEl = document.getElementById('colorName');
  if (nameEl) nameEl.textContent = name;
  if (img) {
    const main = document.getElementById('galMain');
    main.innerHTML = `<div class="art photo"><img class="art-img gallery-main-img" src="${img}" alt="Product" loading="eager" decoding="async"><span class="frame"></span></div>`;
    const thumbs = document.querySelector('.thumbs');
    if (thumbs) {
      Array.from(thumbs.children).forEach(t => t.classList.remove('active'));
      const firstThumb = thumbs.children[0];
      if (firstThumb) {
        const existingImg = firstThumb.querySelector('.art-img');
        if (existingImg) { existingImg.src = img; }
        else { firstThumb.innerHTML = `<img class="art-img" src="${img}" alt="Product" loading="lazy" decoding="async">`; }
        firstThumb.setAttribute('onclick', `swapMainPhoto('${img}',this)`);
        firstThumb.classList.add('active');
      }
    }
  }
}
function swapMainPhoto(img, thumb){
  const main = document.getElementById('galMain');
  if (!main) return;
  const existImg = main.querySelector('.art-img.gallery-main-img');
  if (existImg && existImg.src !== img) {
    // Smooth crossfade: fade out → swap src → fade in
    existImg.style.transition = 'opacity 0.18s ease';
    existImg.style.opacity = '0';
    setTimeout(function() {
      existImg.src = img;
      existImg.style.opacity = '1';
      // Re-wire zoom after swap
      setTimeout(initImageZoom, 280);
    }, 180);
  } else if (!existImg) {
    main.querySelector('.art.photo') && (main.querySelector('.art.photo').innerHTML =
      `<img class="art-img gallery-main-img" src="${img}" alt="Product" loading="eager" decoding="async"><span class="frame"></span>`);
  }
  if (thumb) {
    Array.from(thumb.parentElement.children)
         .forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  }
  // Keep lightbox and counter in sync
  const idx = _pdpImages.indexOf(img);
  if (idx > -1) {
    lbIndex = idx;
    const cur = document.getElementById('galCountCur');
    if (cur) cur.textContent = idx + 1;
  }
}
/* Navigate product gallery by step direction (-1 or +1) */
function galleryNavStep(dir) {
  if (!_pdpImages.length) return;
  const thumbs = Array.from(document.querySelectorAll('#galThumbs .art'));
  const activeIdx = thumbs.length
    ? thumbs.findIndex(t => t.classList.contains('active'))
    : lbIndex;
  const cur = activeIdx < 0 ? 0 : activeIdx;
  const next = ((cur + dir) + _pdpImages.length) % _pdpImages.length;
  swapMainPhoto(_pdpImages[next], thumbs[next] || null);
  // Preload the image after next
  const after = (next + 1) % _pdpImages.length;
  if (_pdpImages[after]) {
    var lnk = document.createElement('link');
    lnk.rel = 'preload'; lnk.as = 'image'; lnk.href = _pdpImages[after];
    document.head.appendChild(lnk);
  }
}
function nlSubmit(e){
  e.preventDefault();
  var form = e.target;
  var email = form.querySelector('input[type=email]').value;
  var btn = form.querySelector('button');
  var originalText = btn.textContent;
  btn.textContent = '...';
  btn.disabled = true;

  var realForm = document.getElementById('RealNewsletterForm');
  var fd = new FormData(realForm);
  fd.append('contact[email]', email);

  fetch('/contact', { method: 'POST', body: fd })
    .then(function(){
      document.getElementById('nlok').classList.add('show');
      form.reset();
    })
    .catch(function(){
      alert('Something went wrong — please try again.');
    })
    .finally(function(){
      btn.textContent = originalText;
      btn.disabled = false;
    });

  return false;
}
function formSubmit(e,id){
  e.preventDefault();
  var name = document.getElementById('contactName').value;
  var email = document.getElementById('contactEmail').value;
  var subject = document.getElementById('contactSubject').value;
  var message = document.getElementById('contactMessage').value;
  var msg = "New inquiry from website:%0A" +
            "Name: " + name + "%0A" +
            "Email: " + email + "%0A" +
            "Subject: " + subject + "%0A" +
            "Message: " + message;
  var phone = "966593365316";
  var waUrl = "https://wa.me/" + phone + "?text=" + msg.split(' ').join('%20');
  window.open(waUrl, '_blank');
  document.getElementById(id).classList.add('show');
  e.target.reset();
  return false;
}
function trackSubmit(e){
  e.preventDefault();
  document.getElementById('trackResult').style.display = 'block';
  return false;
}
function openLB(word, style, img){
  if (img) { openPhotoLB([img], 0); return; }
  const lb = document.getElementById('lightbox');
  const art = document.getElementById('lbArt');
  art.className = 'lb-art art ' + style;
  art.style.backgroundImage = '';
  art.querySelector('.cal').textContent = word;
  lb.classList.add('on');
}
function closeLB(){
  document.getElementById('lightbox').classList.remove('on');
}

/* ============ TESTIMONIAL SLIDER ============ */
let slideI = 0, slideT;
function initSlider(){
  clearInterval(slideT);
  slideI = 0;
  slideT = setInterval(()=> setSlide((slideI+1)%4), 4500);
}
function setSlide(i){
  slideI = i;
  const slides = document.querySelectorAll('.tslide');
  const dots   = document.querySelectorAll('.tdot');
  if (!slides.length) return;
  slides.forEach((s, idx)=> s.classList.toggle('active', idx===i));
  dots.forEach((d, idx)=> d.classList.toggle('active', idx===i));
}

/* ============ HEADER SCROLL ============ */
window.addEventListener('scroll',()=>{
  document.getElementById('header')
          .classList.toggle('scrolled', window.scrollY>60);
});

/* ============ CUSTOM CURSOR ============ */
const cur = document.querySelector('.cursor'),
      ring = document.querySelector('.cring');
let mx=0, my=0, rx=0, ry=0;
let _draggingSlider = false;

window.addEventListener('mousemove', e=>{
  mx = e.clientX; my = e.clientY;
  cur.style.left = mx+'px'; cur.style.top = my+'px';
});
document.addEventListener('mousedown', e=>{
  if (e.target.matches('input[type="range"]')) _draggingSlider = true;
});
document.addEventListener('mouseup', ()=>{ _draggingSlider = false; });

function ringLoop(){
  if (_draggingSlider) {
    rx = mx; ry = my;
  } else {
    rx += (mx - rx)*.18;
    ry += (my - ry)*.18;
  }
  ring.style.left = rx+'px';
  ring.style.top = ry+'px';
  requestAnimationFrame(ringLoop);
}
ringLoop();

document.addEventListener('mouseover', e=>{
  if (e.target.closest('a,button,.card,.chip,.vopt,.cat-row,.coll-banner,.round-arrow,.art')) {
    ring.classList.add('hov');
    cur.classList.add('hov');
  }
});
document.addEventListener('mouseout', e=>{
  if (e.target.closest('a,button,.card,.chip,.vopt,.cat-row,.coll-banner,.round-arrow,.art')) {
    ring.classList.remove('hov');
    cur.classList.remove('hov');
  }
});

/* ============ WISHLIST ============ */
function toggleWishlist(id, btn) {
  id = String(id);
  const idx = WISHLIST.indexOf(id);
  if (idx > -1) {
    WISHLIST.splice(idx, 1);
    btn.classList.remove('wl-on');
    btn.querySelector('.wl-path').style.fill = '';
    btn.querySelector('.wl-path').style.stroke = '';
  } else {
    WISHLIST.push(id);
    btn.classList.add('wl-on');
  }
  localStorage.setItem('al_wl', JSON.stringify(WISHLIST));
  updateWishlistCount();
}
function updateWishlistCount() {
  const el = document.getElementById('wlCount');
  if (!el) return;
  const n = WISHLIST.length;
  el.textContent = n;
  el.classList.toggle('has-items', n > 0);
}

/* ============ RECENTLY VIEWED ============ */
function trackRecentlyViewed(id) {
  id = String(id);
  RECENT = RECENT.filter(x => x !== id);
  RECENT.unshift(id);
  if (RECENT.length > 8) RECENT = RECENT.slice(0, 8);
  localStorage.setItem('al_rv', JSON.stringify(RECENT));
}
function recentlyViewedHTML(currentId) {
  if (THEME.features && THEME.features.enableRecentlyViewed === false) return '';
  const ids = RECENT.filter(id => String(id) !== String(currentId)).slice(0, 4);
  const items = ids.map(id => PRODUCTS.find(p => String(p.id) === String(id))).filter(Boolean);
  if (!items.length) return '';
  return `
<section class="recently-viewed">
  <div class="wrap">
    <div class="rv2-title reveal">Recently Viewed</div>
    <div class="grid4 stagger reveal">${items.map(card).join('')}</div>
  </div>
</section>`;
}

/* ============ COMPARE ============ */
function addToCompare(id) {
  const p = PRODUCTS.find(x => String(x.id) === String(id));
  if (!p) return;
  const idx = COMPARE.findIndex(x => String(x.id) === String(id));
  if (idx > -1) {
    COMPARE.splice(idx, 1);
  } else {
    if (COMPARE.length >= 2) COMPARE.shift();
    COMPARE.push(p);
  }
  renderCompareBar();
  if (document.getElementById('shopWrap')) renderShop();
}
function clearCompare() {
  COMPARE = [];
  renderCompareBar();
  if (document.getElementById('shopWrap')) renderShop();
}
function renderCompareBar() {
  const bar = document.getElementById('compareBar');
  const itemsEl = document.getElementById('cbItems');
  const goBtn = document.getElementById('cbGoBtn');
  if (!bar || !itemsEl) return;
  bar.classList.toggle('show', COMPARE.length > 0 && !(THEME.features && THEME.features.enableCompare === false));
  itemsEl.innerHTML = [0,1].map(i => {
    const p = COMPARE[i];
    if (p) {
      const ciMedia = p.image
        ? `<img class="ci-art-img" src="${p.image}" alt="${p.name}" loading="lazy" decoding="async">`
        : `<div class="ci-art ci-art-noimg" style="background:linear-gradient(135deg,var(--emerald-deep),var(--emerald))"></div>`;
      return `<div class="compare-item">
        ${ciMedia}
        <span class="ci-name">${p.name}</span>
        <button class="ci-rm" onclick="addToCompare(${p.id})">×</button>
      </div>`;
    }
    return `<div class="compare-empty">+ Add Product</div>`;
  }).join('');
  if (goBtn) goBtn.disabled = COMPARE.length < 2;
}

/* ============ PHOTO LIGHTBOX ============ */
let lbIndex = 0;
function openPhotoLB(images, idx) {
  if (!images || !images.length) return;
  _pdpImages = images;
  lbIndex = idx || 0;
  const lb = document.getElementById('photoLB');
  if (!lb) return;
  lb.classList.add('on');
  _renderLBSlide();
}
function _renderLBSlide() {
  const img = document.getElementById('lbMainImg');
  const counter = document.getElementById('lbCounter');
  const thumbs = document.getElementById('lbThumbs');
  if (!img) return;
  img.style.opacity = '0';
  img.src = _pdpImages[lbIndex];
  img.onload = () => { img.style.opacity = '1'; };
  if (counter) counter.textContent = `${lbIndex + 1} / ${_pdpImages.length}`;
  if (thumbs) {
    thumbs.innerHTML = _pdpImages.map((src, i) =>
      `<img class="ph-lb-thumb ${i===lbIndex?'active':''}" src="${src}" onclick="lbGo(${i})" alt="" loading="lazy">`
    ).join('');
  }
}
function lbNav(dir) {
  lbIndex = (lbIndex + dir + _pdpImages.length) % _pdpImages.length;
  _renderLBSlide();
}
function lbGo(i) {
  lbIndex = i;
  _renderLBSlide();
}
function closePhotoLB() {
  const lb = document.getElementById('photoLB');
  if (lb) lb.classList.remove('on');
}

/* ============ STICKY PRODUCT BAR ============ */
let _stickyObs = null;
function initStickyBar(p) {
  const bar = document.getElementById('stickyPdpBar');
  if (!bar) return;
  const spbMedia = p.image
    ? `<img class="spb-art-img" src="${p.image}" alt="${p.name}" loading="eager" decoding="async">`
    : `<div class="spb-art spb-art-noimg" style="background:linear-gradient(135deg,var(--emerald-deep),var(--emerald))"></div>`;
  bar.innerHTML = `
    ${spbMedia}
    <div class="spb-info">
      <div class="spb-name">${p.name}</div>
      <div class="spb-stars">${'★'.repeat(p.rating)}${'☆'.repeat(5-p.rating)}</div>
      <div class="spb-price">${money(p.price)}</div>
    </div>
    <button class="btn emerald" onclick="addToCart('${p.id}')">Add to Cart</button>`;
  bar.setAttribute('aria-hidden', 'false');
  // Show bar when product title scrolls out of view
  const titleEl = document.querySelector('.pdp-info h1');
  if (titleEl) {
    _stickyObs = new IntersectionObserver(entries => {
      entries.forEach(en => bar.classList.toggle('visible', !en.isIntersecting));
    }, { threshold: 0 });
    _stickyObs.observe(titleEl);
  }
}
function destroyStickyBar() {
  if (_stickyObs) { _stickyObs.disconnect(); _stickyObs = null; }
  const bar = document.getElementById('stickyPdpBar');
  if (bar) { bar.innerHTML = ''; bar.classList.remove('visible'); bar.setAttribute('aria-hidden','true'); }
}

/* ============ VIDEO EMBED ============ */
function toEmbedUrl(url) {
  url = (url || '').trim();
  const m = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
  if (m) return 'https://www.youtube.com/embed/' + m[1] + '?rel=0';
  const v = url.match(/vimeo\.com\/(\d+)/);
  if (v) return 'https://player.vimeo.com/video/' + v[1];
  return url;
}

/* ============ KEYBOARD SHORTCUTS ============ */
document.addEventListener('keydown', e => {
  const lb = document.getElementById('photoLB');
  if (lb && lb.classList.contains('on')) {
    if (e.key === 'ArrowLeft')  lbNav(-1);
    if (e.key === 'ArrowRight') lbNav(1);
    if (e.key === 'Escape')     closePhotoLB();
    return;
  }
  // Size guide removed — sg reference left intentionally harmless (modal no longer exists)
  if (e.key === 'Escape') {
    closeCart();
    closeLB();
    closeQuickView();
  }
});

/* ============ MOBILE REVIEW SWIPER ============ */
function buildReviewSwiper(containerEl, allReviews) {
  if (!containerEl || !allReviews.length) return;
  const wrap = document.createElement('div');
  wrap.className = 'rv-swiper-wrap';
  const track = document.createElement('div');
  track.className = 'rv-swiper-track';
  allReviews.forEach((r, i) => {
    const div = document.createElement('div');
    div.innerHTML = reviewCard(r, i);
    const card = div.firstElementChild;
    if (card) track.appendChild(card);
  });
  wrap.appendChild(track);

  // Dots
  const dots = document.createElement('div');
  dots.className = 'rv-swiper-dots';
  allReviews.forEach((_, i) => {
    const d = document.createElement('div');
    d.className = 'rv-swiper-dot' + (i === 0 ? ' active' : '');
    d.onclick = () => swiperGoTo(i);
    dots.appendChild(d);
  });
  wrap.appendChild(dots);

  // Arrow buttons
  const arrows = document.createElement('div');
  arrows.className = 'rv-swiper-arrows';
  const prev = document.createElement('button');
  prev.className = 'rv-swiper-btn';
  prev.innerHTML = '&#8249;';
  prev.setAttribute('aria-label', 'Previous review');
  prev.onclick = () => swiperGoTo(swiperIdx - 1);
  const next = document.createElement('button');
  next.className = 'rv-swiper-btn';
  next.innerHTML = '&#8250;';
  next.setAttribute('aria-label', 'Next review');
  next.onclick = () => swiperGoTo(swiperIdx + 1);
  arrows.appendChild(prev);
  arrows.appendChild(next);
  wrap.appendChild(arrows);

  containerEl.parentNode.insertBefore(wrap, containerEl);

  let swiperIdx = 0;
  let startX = 0, isDragging = false, startTranslate = 0;
  const total = allReviews.length;

  function swiperGoTo(idx) {
    swiperIdx = ((idx % total) + total) % total;
    track.style.transition = 'transform .38s cubic-bezier(.25,1,.5,1)';
    track.style.transform = `translateX(-${swiperIdx * 100}%)`;
    dots.querySelectorAll('.rv-swiper-dot').forEach((d, i) =>
      d.classList.toggle('active', i === swiperIdx)
    );
  }

  // Touch/pointer drag
  function pStart(e) {
    isDragging = true;
    startX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
    startTranslate = -swiperIdx * 100;
    track.style.transition = 'none';
  }
  function pMove(e) {
    if (!isDragging) return;
    const cx = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
    const pct = ((cx - startX) / wrap.offsetWidth) * 100;
    track.style.transform = `translateX(${startTranslate + pct}%)`;
  }
  function pEnd(e) {
    if (!isDragging) return;
    isDragging = false;
    const cx = e.type === 'touchend' ? e.changedTouches[0].clientX : e.clientX;
    const diff = cx - startX;
    if (diff < -40) swiperGoTo(swiperIdx + 1);
    else if (diff > 40) swiperGoTo(swiperIdx - 1);
    else swiperGoTo(swiperIdx);
  }

  track.addEventListener('touchstart', pStart, { passive: true });
  track.addEventListener('touchmove', pMove, { passive: true });
  track.addEventListener('touchend', pEnd);
  track.addEventListener('mousedown', pStart);
  window.addEventListener('mousemove', e => isDragging && pMove(e));
  window.addEventListener('mouseup', e => isDragging && pEnd(e));
}

function initReviewSwiper() {
  if (window.innerWidth > 900) return;
  if (!REVIEWS.length) return;
  // Already built?
  if (document.querySelector('.rv-swiper-wrap')) return;
  const grid = document.querySelector('.rv-grid.desktop-grid');
  if (grid) buildReviewSwiper(grid, REVIEWS);
}

/* ============ PRODUCT GALLERY SWIPE (MOBILE) ============ */
function initGallerySwipe() {
  const galMain = document.getElementById('galMain');
  if (!galMain || _pdpImages.length < 2) return;
  // Remove any prior listeners by replacing the node's data-swipe flag
  if (galMain.dataset.swipeInit) return;
  galMain.dataset.swipeInit = '1';
  var touchStartX = 0, touchStartY = 0, _pinching = false;
  galMain.addEventListener('touchstart', function(e) {
    if (e.touches.length === 2) { _pinching = true; return; }
    _pinching = false;
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  }, { passive: true });
  galMain.addEventListener('touchend', function(e) {
    if (_pinching) { _pinching = false; return; }
    if (e.changedTouches.length === 0) return;
    const dx = e.changedTouches[0].clientX - touchStartX;
    const dy = e.changedTouches[0].clientY - touchStartY;
    // Only treat as a horizontal swipe if more horizontal than vertical
    if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
    galleryNavStep(dx < 0 ? 1 : -1);
  }, { passive: true });
}

/* ============ MOBILE PINCH-TO-ZOOM ============ */
function initMobilePinchZoom() {
  if (window.innerWidth > 900) return; // desktop uses click-to-zoom
  const galMain = document.getElementById('galMain');
  const img = galMain && galMain.querySelector('.art-img.gallery-main-img');
  if (!galMain || !img) return;
  if (galMain.dataset.pinchInit) return;
  galMain.dataset.pinchInit = '1';

  var scale = 1, startDist = 0, startScale = 1;
  var panX = 0, panY = 0, startPanX = 0, startPanY = 0;
  var startMidX = 0, startMidY = 0;
  var isPinching = false, isPanning = false;

  function applyTransform(animate) {
    img.style.transition = animate ? 'transform .3s ease' : 'none';
    img.style.transform = `translateZ(0) translate(${panX}px,${panY}px) scale(${scale})`;
  }
  function resetTransform() {
    scale = 1; panX = 0; panY = 0; applyTransform(true);
  }
  function clampPan() {
    var rect = galMain.getBoundingClientRect();
    var maxX = rect.width * (scale - 1) / 2;
    var maxY = rect.height * (scale - 1) / 2;
    panX = Math.max(-maxX, Math.min(maxX, panX));
    panY = Math.max(-maxY, Math.min(maxY, panY));
  }

  galMain.addEventListener('touchstart', function(e) {
    if (e.touches.length === 2) {
      isPinching = true; isPanning = false;
      startDist = Math.hypot(
        e.touches[1].clientX - e.touches[0].clientX,
        e.touches[1].clientY - e.touches[0].clientY
      );
      startScale = scale;
    } else if (e.touches.length === 1 && scale > 1.05) {
      isPanning = true;
      startPanX = panX; startPanY = panY;
      startMidX = e.touches[0].clientX;
      startMidY = e.touches[0].clientY;
    }
  }, { passive: true });

  galMain.addEventListener('touchmove', function(e) {
    if (isPinching && e.touches.length === 2) {
      e.preventDefault();
      var dist = Math.hypot(
        e.touches[1].clientX - e.touches[0].clientX,
        e.touches[1].clientY - e.touches[0].clientY
      );
      scale = Math.max(1, Math.min(4, startScale * (dist / startDist)));
      applyTransform(false);
    } else if (isPanning && e.touches.length === 1 && scale > 1.05) {
      e.preventDefault();
      panX = startPanX + (e.touches[0].clientX - startMidX);
      panY = startPanY + (e.touches[0].clientY - startMidY);
      clampPan();
      applyTransform(false);
    }
  }, { passive: false });

  galMain.addEventListener('touchend', function(e) {
    if (e.touches.length < 2) isPinching = false;
    if (e.touches.length === 0) {
      isPanning = false;
      clampPan();
      if (scale < 1.1) resetTransform();
      else applyTransform(true);
    }
  }, { passive: true });

  // Double-tap to reset zoom
  var lastTap = 0;
  galMain.addEventListener('touchend', function(e) {
    var now = Date.now();
    if (now - lastTap < 300 && e.changedTouches.length === 1) {
      if (scale > 1.1) resetTransform();
    }
    lastTap = now;
  }, { passive: true });
}

/* ============ PRELOAD HOVER IMAGES ============ */
/* Call after each shop/home render so the second card-swap image is
   fetched before the user ever hovers — eliminating the blank-frame
   flash on the very first hover event.                             */
function preloadCardHoverImages() {
  var _ric = window.requestIdleCallback || function(cb){ setTimeout(cb, 200); };
  _ric(function() {
    PRODUCTS.forEach(function(p) {
      var allImgs = p.images && p.images.length ? p.images : [p.image2].filter(Boolean);
      var hoverSrc = allImgs[1] || p.image2;
      if (!hoverSrc) return;
      var img = new Image();
      img.src = hoverSrc;
      img.decoding = 'async';
    });
  }, { timeout: 2000 });
}

/* ============ PRODUCT PAGE SECTION HELPERS ============ */

/* Parse feature lines: "icon | Label | Description" */
function _parseFeatures(raw) {
  if (!raw) return null;
  return raw.split('\n').map(function(l){
    var parts = l.split('|').map(function(s){ return s.trim(); });
    return { icon: parts[0]||'✦', label: parts[1]||'Feature', desc: parts[2]||'' };
  }).filter(function(f){ return f.label; });
}

/* Parse spec lines: "Property | Value" */
function _parseSpecs(raw) {
  if (!raw) return null;
  return raw.split('\n').map(function(l){
    var parts = l.split('|').map(function(s){ return s.trim(); });
    return { prop: parts[0]||'', val: parts[1]||'' };
  }).filter(function(s){ return s.prop && s.val; });
}

/* Parse per-product FAQ textarea: Q: ...\nA: ...\n--- */
function _parseFaqsRaw(raw) {
  if (!raw) return null;
  var items = raw.split(/\n---+\n?/);
  return items.map(function(block) {
    var qm = block.match(/Q:\s*(.+)/);
    var am = block.match(/A:\s*([\s\S]+)/);
    return qm && am ? { q: qm[1].trim(), a: am[1].trim() } : null;
  }).filter(Boolean);
}

/* Determine if a section is enabled for this product */
function _pdpSectionOn(p, key) {
  if (!p.sections) return true; // no config = all on
  return p.sections[key] !== false;
}

/* Features strip — uses p.features_list if set, else built-in defaults */
function pdpFeaturesHTML(p) {
  if (!_pdpSectionOn(p, 'features')) return '';
  var feats = _parseFeatures(p.features_list);
  if (!feats) {
    feats = [
      { icon:'✦', label:'Handmade',       desc:'' },
      { icon:'⬡', label:'Premium Acrylic',desc:'' },
      { icon:'✂', label:'Laser Cut',      desc:'' },
      { icon:'⚓', label:'Easy Install',   desc:'' },
      { icon:'☀', label:'Fade Resistant', desc:'' },
      { icon:'☁', label:'Lightweight',    desc:'' }
    ];
  }
  return '<div class="product-features">'
    + feats.map(function(f){
        return '<div class="feat-item" title="' + (f.desc||f.label) + '">'
          + '<div class="feat-icon">' + f.icon + '</div>'
          + '<div class="feat-label">' + f.label + '</div>'
          + '</div>';
      }).join('')
    + '</div>';
}

/* FAQs accordion — uses per-product faqs_raw if set, else global PFAQ */
function pdpFaqsHTML(p) {
  if (!_pdpSectionOn(p, 'faqs')) return '';
  var items = _parseFaqsRaw(p.faqs_raw) || PFAQ;
  if (!items.length) return '';
  return '<div style="margin-top:40px">'
    + items.map(function(f, i){
        return '<div class="acc-item ' + (i===0?'open':'') + '">'
          + '<button class="acc-q" onclick="toggleAcc(this)"><span>' + f.q + '</span><span class="ico">+</span></button>'
          + '<div class="acc-a"><p>' + f.a + '</p></div>'
          + '</div>';
      }).join('')
    + '</div>';
}

/* All below-fold sections — ordered and gated by p.sections config */
function pdpBelowFoldSections(p) {
  var out = '';
  // Description
  if (_pdpSectionOn(p, 'description') && p.description) {
    out += '<section style="padding:clamp(48px,6vw,80px) 0">'
      + '<div class="wrap"><div class="pdp-description reveal">'
      + p.description
      + '</div></div></section>';
  }
  // Story
  if (_pdpSectionOn(p, 'story') && p.story_body) {
    out += '<section style="background:var(--stone);padding:clamp(48px,6vw,80px) 0">'
      + '<div class="wrap grid2">'
      + '<div class="reveal left">'
      + '<p class="eyebrow">The Story</p><div class="gold-line"></div>'
      + '<h2 style="font-size:clamp(24px,3.5vw,44px)">' + (p.story_title || 'The Story Behind This Piece') + '</h2>'
      + '</div>'
      + '<div class="reveal right"><p>' + p.story_body + '</p></div>'
      + '</div></section>';
  }
  // Specifications
  var specs = _parseSpecs(p.specs);
  if (_pdpSectionOn(p, 'specs') && specs && specs.length) {
    var specRows = specs.map(function(s){
      return '<tr><td style="font-weight:600;padding:10px 16px 10px 0;border-bottom:1px solid rgba(20,20,20,.08);white-space:nowrap">' + s.prop + '</td>'
        + '<td style="padding:10px 0;border-bottom:1px solid rgba(20,20,20,.08);opacity:.75">' + s.val + '</td></tr>';
    }).join('');
    out += '<section style="padding:clamp(48px,6vw,80px) 0">'
      + '<div class="wrap"><div class="sec-head reveal" style="text-align:left;margin-bottom:28px">'
      + '<p class="eyebrow">Specifications</p><div class="gold-line"></div>'
      + '<h2 style="font-size:clamp(22px,3vw,36px)">Technical Details</h2>'
      + '</div>'
      + '<div class="reveal"><table style="width:100%;max-width:560px;border-collapse:collapse">' + specRows + '</table></div>'
      + '</div></section>';
  }
  // Care
  if (_pdpSectionOn(p, 'care') && p.care) {
    out += '<section style="background:var(--stone);padding:clamp(40px,5vw,72px) 0">'
      + '<div class="wrap"><div class="sec-head reveal" style="text-align:left;margin-bottom:20px">'
      + '<p class="eyebrow">Care</p><div class="gold-line"></div>'
      + '<h2 style="font-size:clamp(22px,3vw,36px)">Care Instructions</h2>'
      + '</div>'
      + '<div class="reveal" style="max-width:680px;line-height:1.8;opacity:.85">' + p.care + '</div>'
      + '</div></section>';
  }
  // Why Choose
  if (_pdpSectionOn(p, 'why_choose') && p.why_choose) {
    out += '<section style="padding:clamp(48px,6vw,80px) 0">'
      + '<div class="wrap"><div class="sec-head reveal" style="text-align:left;margin-bottom:20px">'
      + '<p class="eyebrow">Why This Piece</p><div class="gold-line"></div>'
      + '<h2 style="font-size:clamp(22px,3vw,36px)">Why Choose This</h2>'
      + '</div>'
      + '<div class="reveal" style="max-width:680px;line-height:1.8">' + p.why_choose + '</div>'
      + '</div></section>';
  }
  // Installation (video + steps)
  if (_pdpSectionOn(p, 'installation')) {
    out += installationVideoSectionHTML(p);
  }
  // Frequently Bought Together
  if (_pdpSectionOn(p, 'fbt') && p.fbt_ids) {
    var fbtProds = p.fbt_ids.split(',').map(function(id){
      return PRODUCTS.find(function(x){ return String(x.id) === id.trim(); });
    }).filter(Boolean).slice(0, 4);
    if (fbtProds.length) {
      var allProds = [p].concat(fbtProds);
      var fbtTotal = allProds.reduce(function(s, x){ return s + x.price; }, 0);
      out += '<section style="background:var(--stone);padding:clamp(48px,6vw,80px) 0">'
        + '<div class="wrap"><div class="sec-head reveal" style="margin-bottom:32px">'
        + '<p class="eyebrow">Complete the Look</p><div class="gold-line"></div>'
        + '<h2 style="font-size:clamp(22px,3vw,36px)">Frequently Bought Together</h2>'
        + '</div>'
        + '<div class="fbt-wrap reveal">'
        + allProds.map(function(prod, i){
            var img = prod.image
              ? '<img class="art-img" src="' + prod.image + '" alt="' + prod.name + '" loading="lazy" decoding="async"><span class="frame"></span>'
              : '<span class="cal ar" lang="ar">' + prod.ar + '</span><span class="frame"></span>';
            return '<div class="fbt-item" onclick="go(\'product-' + prod.id + '\')" style="cursor:pointer">'
              + '<div class="art' + (prod.image ? ' photo' : ' ' + prod.style) + ' fbt-art">' + img + '</div>'
              + '<div class="fbt-name">' + prod.name + '</div>'
              + '<div class="fbt-price">' + money(prod.price) + '</div>'
              + '</div>'
              + (i < allProds.length-1 ? '<div class="fbt-plus">+</div>' : '');
          }).join('')
        + '<div class="fbt-total-row">'
        + '<span style="font-size:14px;opacity:.6">Bundle total:</span> '
        + '<span style="font-family:var(--f-display);font-size:20px;font-weight:700;color:var(--emerald-deep)">' + money(fbtTotal) + '</span>'
        + '</div></div>'
        + '</div></section>';
    }
  }
  // Custom section
  if (p.custom_title && p.custom_body) {
    out += '<section style="padding:clamp(48px,6vw,80px) 0">'
      + '<div class="wrap"><div class="sec-head reveal" style="text-align:left;margin-bottom:20px">'
      + '<div class="gold-line"></div>'
      + '<h2 style="font-size:clamp(22px,3vw,36px)">' + p.custom_title + '</h2>'
      + '</div>'
      + '<div class="reveal" style="max-width:760px;line-height:1.8">' + p.custom_body + '</div>'
      + '</div></section>';
  }
  return out;
}

/* ============ INSTALLATION MADE SIMPLE SECTION ============ */
function installationVideoSectionHTML(p) {
  var video = p.video_url || (CONTENT.installationVideo || '');
  var hasVideo = !!video;
  var isYT = hasVideo && (video.includes('youtube') || video.includes('youtu.be'));
  var isVimeo = hasVideo && video.includes('vimeo');

  var playerHTML = '';
  if (hasVideo) {
    if (isYT || isVimeo) {
      playerHTML = '<iframe src="' + toEmbedUrl(video) + '" allowfullscreen loading="lazy" title="Installation guide" allow="autoplay; encrypted-media"></iframe>';
    } else {
      playerHTML = '<video src="' + video + '" controls playsinline preload="none"'
        + (p.image ? ' poster="' + p.image + '"' : '') + '></video>';
    }
  } else {
    // Placeholder — merchant has not set a video yet
    playerHTML = '<div class="is-video-placeholder">'
      + (p.image ? '<img class="is-video-thumb" src="' + p.image + '" alt="' + (p.name||'') + '" loading="lazy" decoding="async">' : '')
      + '<div class="is-video-thumb-overlay">'
      + '<button class="is-play-btn" aria-label="Play installation video" disabled title="Upload a video URL in the product block settings to enable this player">'
      + '<svg width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M10 8.5l12 5.5-12 5.5V8.5z" fill="rgba(224,177,89,.9)"/></svg>'
      + '</button>'
      + '<p style="font-size:11px;color:rgba(247,245,240,.45);letter-spacing:.12em;text-transform:uppercase;margin-top:14px">Add a video URL in the product settings to show it here</p>'
      + '</div>'
      + '</div>';
  }

  var steps = [
    { icon:'🧹', title:'Clean the Wall',       desc:'Wipe the surface clean and dry — dust-free for the best adhesion.' },
    { icon:'🩹', title:'Peel the Adhesive',    desc:'Carefully peel the backing from the included premium adhesive pads.' },
    { icon:'📐', title:'Position the Artwork', desc:'Hold the piece in place and adjust until the alignment feels right.' },
    { icon:'✋', title:'Press Firmly',          desc:'Apply even pressure across the surface for 30 seconds to bond.' },
    { icon:'✨', title:'Enjoy Your Wall Art',   desc:'Step back and admire your new statement piece.' }
  ];
  var stepsHTML = steps.map(function(s, i) {
    return '<div class="is-step">'
      + '<div class="is-step-num">' + (i + 1) + '</div>'
      + '<div class="is-step-icon">' + s.icon + '</div>'
      + '<div class="is-step-title">' + s.title + '</div>'
      + '<div class="is-step-desc">' + s.desc + '</div>'
      + '</div>';
  }).join('');

  var badges = [
    { icon:'⚡', label:'No Drilling Required' },
    { icon:'🔧', label:'Easy Installation' },
    { icon:'✅', label:'Premium Adhesive Included' },
    { icon:'⏱', label:'~5 Minutes to Install' }
  ];
  var badgesHTML = badges.map(function(b) {
    return '<div class="is-badge"><span class="is-badge-icon">' + b.icon + '</span>' + b.label + '</div>';
  }).join('');

  return '<section class="install-section">'
    + '<div class="wrap">'
    + '<div class="sec-head reveal">'
    + '<p class="eyebrow">Step by Step</p>'
    + '<div class="gold-line"></div>'
    + '<h2>Installation Made Simple</h2>'
    + '<p class="is-subtitle">Install your Arabic calligraphy in just a few minutes.</p>'
    + '</div>'
    + '<div class="is-steps" id="isSteps">' + stepsHTML + '</div>'
    + '<div class="is-badges reveal">' + badgesHTML + '</div>'
    + '</div>'
    + '</section>';
}

/* Animate installation steps into view on scroll */
function initInstallSteps() {
  var steps = document.querySelectorAll('.is-step');
  if (!steps.length) return;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(en) {
      if (en.isIntersecting) { en.target.classList.add('in'); obs.unobserve(en.target); }
    });
  }, { threshold: 0.15 });
  steps.forEach(function(s) { obs.observe(s); });
}

/* ============ FIND YOUR PERFECT CALLIGRAPHY — QUIZ (CONFIG-DRIVEN) ============ */

/* Parse a single option string from the Shopify textarea setting.
   Format: "Label | 🎨 icon | cats: A, B | style: e,g | min: 100 | max: 400 | badge: X | min-rating: 5"
   All parts after the label are optional and order-independent.               */
function _parseQuizOption(str) {
  if (!str || !str.trim()) return null;
  var parts = str.split('|').map(function(s){ return s.trim(); });
  var opt = { label: parts[0], icon: parts[1] || '◆' };
  parts.slice(2).forEach(function(part) {
    var m;
    if ((m = part.match(/^cats:\s*(.+)/i)))      opt.cats = m[1].split(',').map(function(s){ return s.trim(); });
    else if ((m = part.match(/^style:\s*(.+)/i))) opt.style = m[1].split(',').map(function(s){ return s.trim(); });
    else if ((m = part.match(/^min:\s*(\d+)/i)))  opt.minPrice = +m[1];
    else if ((m = part.match(/^max:\s*(\d+)/i)))  opt.maxPrice = +m[1];
    else if ((m = part.match(/^badge:\s*(.+)/i))) opt.badge = m[1].trim();
    else if ((m = part.match(/^min-rating:\s*(\d)/i))) opt.minRating = +m[1];
  });
  return opt.label ? opt : null;
}

/* Build QUIZ_QUESTIONS array from CONTENT.quiz (Shopify section data) */
function _buildQuizQuestions() {
  var cfg = CONTENT.quiz;
  if (!cfg || !cfg.questions || !cfg.questions.length) {
    return []; // quiz section not added yet — page shows "Add quiz section" hint
  }
  return cfg.questions.map(function(q) {
    var rawOpts = q.options || [];
    var opts = rawOpts.map(_parseQuizOption).filter(Boolean);
    return {
      q:    q.text || '',
      icon: q.icon || '✨',
      type: q.type || 'buttons',
      opts: opts,
      manualProductIds: q.manualProductIds ? q.manualProductIds.split(',').map(function(s){ return s.trim(); }).filter(Boolean) : []
    };
  }).filter(function(q){ return q.q && q.opts.length; });
}

/* Lazy-initialised so it reads CONTENT.quiz after all section scripts have run */
var _quizQsCache = null;
function _getQuizQs() {
  if (!_quizQsCache) _quizQsCache = _buildQuizQuestions();
  return _quizQsCache;
}
function _quizCfg() { return CONTENT.quiz || {}; }

function quizScore(product, answers) {
  var score = 0;
  answers.forEach(function(a) {
    if (!a) return;
    if (a.cats && a.cats.includes(product.cat)) score += 3;
    if (a.style && a.style.includes(product.style)) score += 2;
    if (a.minPrice !== undefined && product.price >= a.minPrice) score += 1;
    if (a.maxPrice !== undefined && product.price <= a.maxPrice) score += 1;
    if (a.badge && product.badge === a.badge) score += 2;
    if (a.minRating && product.rating >= a.minRating) score += 1;
  });
  return score;
}

function quizResultReason(product, answers) {
  var reasons = [];
  answers.forEach(function(a) {
    if (!a) return;
    if (a.cats && a.cats.includes(product.cat)) reasons.push(product.cat + ' collection');
    if (a.minPrice !== undefined && a.maxPrice !== undefined && product.price >= a.minPrice && product.price <= a.maxPrice) reasons.push('fits your budget');
  });
  if (product.badge) reasons.push(product.badge);
  if (product.rating >= 5) reasons.push('5-star rated');
  return reasons.length ? reasons.slice(0,2).join(' · ') : 'Matches your preferences';
}

PAGES.quiz = function() {
  _quizAnswers = [];
  _quizQ = 0;
  _quizQsCache = null; // re-read config on every page load
  var cfg = _quizCfg();
  var qs = _getQuizQs();
  if (!qs.length) {
    return '<section class="quiz-page"><div class="wrap" style="text-align:center;padding:clamp(60px,8vw,120px) 0">'
      + '<p class="eyebrow">Quiz</p><div class="gold-line" style="margin:0 auto 20px"></div>'
      + '<h1>Find Your Perfect Calligraphy</h1>'
      + '<p style="opacity:.6;margin-top:20px;max-width:500px;margin-left:auto;margin-right:auto">To enable this quiz, go to the Shopify theme editor, click <strong>Add section</strong> and add the <strong>Quiz — Find Your Piece</strong> section. Then add question blocks and configure the answer options.</p>'
      + '<button class="btn emerald" style="margin-top:32px" onclick="go(\'shop\')">Browse All Pieces →</button>'
      + '</div></section>';
  }
  return '<section class="quiz-page">'
    + '<div class="wrap">'
    + '<div class="quiz-head reveal">'
    + '<p class="eyebrow">Personalised for You</p>'
    + '<div class="gold-line"></div>'
    + '<h1>' + (cfg.title || 'Find Your Perfect Calligraphy') + '</h1>'
    + (cfg.subtitle ? '<p style="opacity:.65;margin-top:14px;max-width:540px;margin-left:auto;margin-right:auto">' + cfg.subtitle + '</p>' : '')
    + '</div>'
    + '<div id="quizWrap">' + _quizStepHTML(0) + '</div>'
    + '</div>'
    + '</section>';
};

function _quizProgressLabel(n, total) {
  var tpl = (_quizCfg().progressLabel || 'Question {n} of {total}');
  return tpl.replace('{n}', n).replace('{total}', total);
}

function _quizStepHTML(qIdx) {
  var qs = _getQuizQs();
  var total = qs.length;
  var pct = Math.round((qIdx / total) * 100);
  var q = qs[qIdx];
  var isDropdown = q.type === 'dropdown';
  var optsHTML = '';
  if (isDropdown) {
    optsHTML = '<div style="margin-bottom:24px">'
      + '<select class="quiz-dropdown" onchange="quizPickIdx(' + qIdx + ',+this.value,null)"'
      + ' style="width:100%;padding:14px 16px;border:1.5px solid rgba(20,20,20,.14);border-radius:10px;font-size:15px;background:rgba(255,255,255,.8);cursor:pointer">'
      + '<option value="" disabled selected>Select an option…</option>'
      + q.opts.map(function(o, oi){ return '<option value="' + oi + '">' + o.icon + ' ' + o.label + '</option>'; }).join('')
      + '</select></div>';
  } else {
    optsHTML = '<div class="quiz-opts">'
      + q.opts.map(function(o, oi) {
          return '<button class="quiz-opt" onclick="quizPickOpt(' + qIdx + ',' + oi + ',this)">'
            + '<span style="font-size:22px">' + o.icon + '</span>'
            + '<span>' + o.label + '</span></button>';
        }).join('')
      + '</div>';
  }
  return '<div class="quiz-progress">'
    + '<div class="quiz-progress-track"><div class="quiz-progress-fill" style="width:' + pct + '%"></div></div>'
    + '<div class="quiz-progress-label">' + _quizProgressLabel(qIdx + 1, total) + '</div>'
    + '</div>'
    + '<div class="quiz-card quiz-card-enter">'
    + '<div class="quiz-q">' + q.icon + '&nbsp; ' + q.q + '</div>'
    + optsHTML
    + '</div>';
}

function quizPickOpt(qIdx, optIdx, btn) {
  Array.from(btn.parentElement.children).forEach(function(b){ b.classList.remove('selected'); });
  btn.classList.add('selected');
  quizPickIdx(qIdx, optIdx, null);
}

function quizPickIdx(qIdx, optIdx, _unused) {
  var qs = _getQuizQs();
  _quizAnswers[qIdx] = qs[qIdx].opts[optIdx];
  var wrap = document.getElementById('quizWrap');
  if (!wrap) return;
  setTimeout(function() {
    var next = qIdx + 1;
    if (next < qs.length) {
      wrap.innerHTML = _quizStepHTML(next);
    } else {
      wrap.innerHTML = _quizResultsHTML();
    }
    var fill = wrap.querySelector('.quiz-progress-fill');
    if (fill) {
      var pct = Math.round((next / qs.length) * 100);
      setTimeout(function(){ fill.style.width = pct + '%'; }, 20);
    }
  }, 260);
}

function _quizResultsHTML() {
  var cfg = _quizCfg();
  var qs = _getQuizQs();

  // Manual pinned recs (always shown)
  var pinnedIds = new Set();
  var pinned = [];
  if (cfg.manualRecs && cfg.manualRecs.length) {
    cfg.manualRecs.forEach(function(r) {
      var prod = PRODUCTS.find(function(p){ return String(p.id) === String(r.productId); });
      if (prod && !pinnedIds.has(String(prod.id))) {
        pinnedIds.add(String(prod.id));
        pinned.push({ p: prod, reason: r.reason || 'Recommended for you', highlight: !!r.highlight });
      }
    });
  }

  // Score remaining products, injecting manual IDs from question options
  var forcedIds = new Set(pinnedIds);
  _quizAnswers.forEach(function(a, qi) {
    if (!a) return;
    var q = qs[qi];
    if (q && q.manualProductIds) {
      q.manualProductIds.forEach(function(id){ forcedIds.add(id); });
    }
    if (a.manualProductIds) a.manualProductIds.forEach(function(id){ forcedIds.add(id); });
  });

  var scored = PRODUCTS
    .filter(function(p){ return !pinnedIds.has(String(p.id)); })
    .map(function(p) {
      var bonus = forcedIds.has(String(p.id)) ? 10 : 0;
      return { p: p, score: quizScore(p, _quizAnswers) + bonus };
    })
    .sort(function(a,b){ return b.score - a.score; })
    .slice(0, 3 - pinned.length);

  var allRecs = pinned.map(function(r){ return { p: r.p, reason: r.reason, highlight: r.highlight }; })
    .concat(scored.map(function(s){ return { p: s.p, reason: quizResultReason(s.p, _quizAnswers), highlight: false }; }));

  var cardsHTML = allRecs.map(function(item) {
    var p = item.p;
    var imgHTML = p.image
      ? '<img class="art-img" src="' + p.image + '" alt="' + p.name + '" loading="lazy" decoding="async"><span class="frame"></span>'
      : '<span class="cal ar" lang="ar">' + p.ar + '</span><span class="frame"></span>';
    var highlight = item.highlight ? ' style="box-shadow:0 0 0 2px var(--gold),0 20px 60px rgba(224,177,89,.2)"' : '';
    return '<div class="quiz-rec-card" onclick="go(\'product-' + p.id + '\')" style="cursor:pointer"' + highlight + '>'
      + (item.highlight ? '<div style="background:var(--gold);color:#141414;font-size:10px;font-weight:700;letter-spacing:.14em;text-align:center;padding:6px;text-transform:uppercase">Top Pick</div>' : '')
      + '<div class="quiz-rec-img"><div class="art' + (p.image ? ' photo' : ' ' + p.style) + '">' + imgHTML + '</div></div>'
      + '<div class="quiz-rec-body">'
      + '<div class="quiz-rec-reason">' + item.reason + '</div>'
      + '<div class="quiz-rec-name">' + p.name + '</div>'
      + '<div class="quiz-rec-price">' + money(p.price) + '</div>'
      + '<button class="btn emerald" style="width:100%;justify-content:center;font-size:13px" onclick="event.stopPropagation();go(\'product-' + p.id + '\')">Shop Now →</button>'
      + '</div></div>';
  }).join('');

  return '<div class="quiz-progress">'
    + '<div class="quiz-progress-track"><div class="quiz-progress-fill" style="width:100%"></div></div>'
    + '<div class="quiz-progress-label">Your results are ready</div>'
    + '</div>'
    + '<div class="quiz-results reveal in">'
    + '<div class="quiz-results-title">' + (cfg.resultsTitle || 'Your Perfect Match') + '</div>'
    + (cfg.resultsDesc ? '<p style="text-align:center;opacity:.65;margin-bottom:28px">' + cfg.resultsDesc + '</p>' : '')
    + '<div class="quiz-recs stagger in">' + cardsHTML + '</div>'
    + '<div class="quiz-restart">'
    + '<button class="btn ghost" onclick="quizRestart()">Retake Quiz</button>'
    + '&nbsp;&nbsp;'
    + '<button class="btn emerald" onclick="go(\'shop\')">Browse All Pieces</button>'
    + '</div></div>';
}

function quizRestart() {
  _quizAnswers = []; _quizQ = 0; _quizQsCache = null;
  var wrap = document.getElementById('quizWrap');
  if (wrap) wrap.innerHTML = _quizStepHTML(0);
}

/* ============ BOOTSTRAP ============ */
async function boot(){
  const hash = location.hash.replace('#/','') || 'home';
  render(hash);
  updateCart();
  await syncShopifyCart();
}
document.addEventListener('DOMContentLoaded', boot);
window.addEventListener('hashchange', ()=>{});
